export default {
    "Project-Id-Version": "",
    "POT-Creation-Date": "2024-08-29T04:43:11.415Z",
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Edito",
    "PO-Revision-Date": "2024-08-29T04:43:11.859Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "10": "10",
        "...": "...",
        "...nie znalazłeś bloku?": "... have you not found the block?",
        "...nie znalazłeś bloku? Dodaj nowy.": "...Didn't find a block? Add a new one.",
        "' + file.filename + '": "' + file.filename + '",
        "' + func.name + '": "' + func.name + '",
        "%0 z %1": "%0 z %1",
        "%0 znaków": "%0 characters",
        "<Brak nazwy>": "<No name>",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "${copied ? 'Copied' : 'Copy'}",
        "${el.text}": "${el.text}",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "${form.variants > 1 ? 'Generate images' : 'Generate image'}",
        "${getCurrentScope().label}": "${getCurrentScope().label}",
        "${item.entityName}": "${item.entityName}",
        "${item.text}": "${item.text}",
        "${loading ? 'Ładowanie elementów...' : 'Nie znaleziono żadnych elementów.'}": "${loading ? 'Loading items...' : 'No items found.'}",
        "${permissions.canPublish ? 'Przejdź do publikacji' : 'Wyślij do publikacji'}": "${permissions.canPublish ? 'Go to publication' : 'Send to publication'}",
        "${props.inputPlaceholder}": "${props.inputPlaceholder}",
        "${props.title}": "${props.title}",
        "${statusIndex === 0 ? 'Powrót' : 'Powrót do edycji artykułu'}": "${statusIndex === 0 ? ' Back' : 'Back to article editing'}",
        "${str}": "${str}",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "${tokenVisibility ? 'Hide' : 'Show'} token",
        "1 godzina": "1 hour",
        "1:1": "1:1",
        "10 minut": "10 minutes",
        "12 godzin": "12 hours",
        "15 minut": "15 minutes",
        "2 dni": "2 days",
        "2 miesiące": "2 months",
        "2 tygodnie": "2 weeks",
        "24 godziny": "24 hours",
        "3 dni": "3 days",
        "3 godziny": "3 hours",
        "3 miesiące": "3 months",
        "30 minut": "30 minutes",
        "4 dni": "4 days",
        "4:7": "4:7",
        "5 dni": "5 days",
        "5 minut": "5 minutes",
        "6 dni": "6 days",
        "6 godzin": "6 hours",
        "7:4": "7:4",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you have to save the form.",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "To be able to test the validity of the keys, first save the form.",
        "Adaptive sampling": "Adaptive sampling",
        "Administracja": "Administration",
        "Administracja - Kraje": "Administration - Countries",
        "Administracja - Miasta": "Administration - Cities",
        "Administracja - Role": "Administration - Roles",
        "Administracja - Stanowiska pracy": "Administration - Positions",
        "Administracja - Użytkownicy": "Administration - Users",
        "Administracja - Województwa": "Administration - Voivodships",
        "Administracja - Zespoły": "Administration - Teams",
        "Administratorzy": "Administrators",
        "Adres": "Address",
        "Adres docelowy": "Destination address",
        "Adres domenowy": "Domain address",
        "Adres domeny": "Domain address",
        "Adres e-mail potwierdzony": "The email address has been confirmed",
        "Adres email": "Email address",
        "Adres email nadawcy": "Sender's email address",
        "Adres IP": "IP address",
        "Adres IP: %0": "Adres IP: %0",
        "Adres kanoniczny": "Canonical address",
        "Adres serwera": "Server address",
        "Adres strony": "Website address",
        "Adres url": "Url",
        "Adres URL": "URL",
        "Adres url do pliku wideo": "Url to video file",
        "Adres URL profilu autora.": "URL of the author profile.",
        "Adres źródłowy": "Source address",
        "Akcent": "Feature",
        "Akceptacja": "Acceptance",
        "Akceptacja dokumentów": "Acceptance of documents",
        "Akceptacja dokumentu": "Acceptance of the document",
        "Akceptacja komentarzy": "Accept comments",
        "Akceptacja własnych dokumentów": "Acceptance of own documents",
        "Akceptacja wszystkich dokumentów": "Acceptance of all documents",
        "Akceptowalny typ plików": "Acceptable file type",
        "Akceptowany format danych": "Accepted data format",
        "Akceptuj": "Accept",
        "Akcja": "Action",
        "Akcje": "Actions",
        "Aktualizacja: {0}": "Update: {0}",
        "Aktualizuj": "Update",
        "Aktualna sesja": "Current session",
        "Aktualne hasło": "Current password",
        "Aktualne urządzenie": "Current device",
        "Aktualności": "News",
        "Aktualności ze strony": "Website news",
        "Aktywacja kont po rejestracji": "Activation of accounts after registration",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywne do": "Active to",
        "Aktywne kanały komunikacji": "Active communication channels",
        "Aktywne od": "Active since",
        "Aktywne sesje": "Active sessions",
        "Aktywne teraz": "Active now",
        "Aktywne zastępstwa": "Active substitutions",
        "Aktywne źródła": "Active sources",
        "Aktywni": "Active",
        "Aktywny": "Active",
        "Aktywuj": "Activate",
        "Aktywuj przerwę techniczną w witrynie": "Activate the site's technical break",
        "Aktywuj tłumaczenia": "Activate translations",
        "Aktywuj zestaw inteligentnych narzędzi": "Activate the smart toolkit",
        "Alert": "Alert",
        "Alfabetycznie": "Alphabetically",
        "Alias": "Alias",
        "Alias został przepięty.": "The alias has been pinned.",
        "Angielski": "English",
        "Ankieta": "Survey",
        "Ankiety": "Surveys",
        "Anonimizuj": "Anonymize",
        "Anonimowy": "Anonymous",
        "Anulowane": "Canceled",
        "Anuluj": "Cancel",
        "Anuluj edycję": "Undo",
        "Aplikacja": "App",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "The application will be restarted within a maximum of 60 seconds.",
        "Apple iPad": "Apple iPad",
        "Apple iPhone 5": "Apple iPhone 5",
        "Apple iPhone 6": "Apple iPhone 6",
        "application/json": "application/json",
        "application/x-www-form-urlencoded": "application/x-www-form-urlencoded",
        "Aranżacja alternatywna": "Alternative arrangement",
        "Aranżacja domyślna": "Default arrangement",
        "Aranżacja główna": "Main arrangement",
        "Aranżacja utowrzona przez": "Arranged by",
        "Aranżacja została dodana.": "The arrangement has been added.",
        "Aranżacja została opublikowana.": "The arrangement has been published.",
        "Aranżacja została usunięta.": "The arrangement has been deleted.",
        "Aranżacja została zachowana.": "The arrangement has been saved.",
        "Aranżacja została zaktualizowana.": "The arrangement has been updated.",
        "Aranżacje": "Arrangements",
        "Archiwum": "Archive",
        "Artykuł": "Article",
        "Artykuł otwarty": "Open article",
        "Artykuł premium": "Premium Article",
        "Artykuł Premium": "Premium Article",
        "Artykuł sponsorowany": "Sponsored article",
        "Artykuły": "Articles",
        "Artykuły ze statusem PRIORYTET": "Articles with PRIORITY status",
        "Asset został aktywowany.": "Asset has been activated.",
        "Asset został wyłączony.": "Asset has been turned off.",
        "Asystenci": "Assistants",
        "Asystent AI": "AI Assistant",
        "Asystent został dodany.": "An assistant has been added.",
        "Asystent został zaktualizowany.": "The assistant has been updated.",
        "Asystenta AI": "AI Assistant",
        "Audio": "Audio",
        "Automatyczna akceptacja": "Auto acceptance",
        "Automatyczna akceptacja komentarzy zalogowanych użytkowników": "Automatic acceptance of comments from logged-in users",
        "Automatyczna akceptacja wszystkich komentarzy": "Automatic acceptance of all comments",
        "Automatyczna publikacja galerii": "Automatic publication of galleries",
        "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "Automatic version acceptance on the publication date. The selected version must be given status \"Completed\"",
        "Automatyczny": "Automatic",
        "Automatyzacja": "Automation",
        "Autor": "Author",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "The author cannot be removed because he is assigned to articles",
        "Autor został dodany.": "The author added.",
        "Autor został usunięty.": "The author has been removed.",
        "Autor został zaktualizowany.": "The author has been updated.",
        "Autorzy": "Authors",
        "Autorzy spoza bazy użytkowników": "Authors outside the user base",
        "Avatar": "Avatar",
        "Azure AD": "Azure AD",
        "Azure AI": "Azure AI",
        "Azure Application Insights": "Azure Application Insights",
        "Azure OpenAI": "Azure OpenAI",
        "Baner został dodany.": "The banner has been added.",
        "Baner został zaktualizowany.": "The banner has been updated.",
        "Banery": "Banners",
        "Banner został usunięty.": "The banner has been removed.",
        "Barwa tekstu": "Text color",
        "Barwa tła": "Background color",
        "Basic Auth": "Basic Auth",
        "Baza danych": "Database",
        "Baza danych tego klienta jest nieaktualna.": "This customer's database is out of date.",
        "Baza dokumentów": "Document database",
        "Bazy danych": "Database",
        "Bez \"http(s)://\" i \"/\" na końcu.": "No \"http(s)://\" and \"/\" at the end.",
        "Bezpieczeństwo": "Safety",
        "Bezpieczne połączenie SSL": "Secure SSL connection",
        "Bezpieczny adres URL": "Secure URL",
        "Bieżący dokument": "Current document",
        "Blik": "BLIK payments",
        "Blok aktywny": "Active block",
        "Blok jest wyłączony dla tej witryny": "The block is disabled for this site",
        "Blok unikalny może zostać użyty tylko raz": "A unique block can only be used once",
        "Blok został usunięty.": "The block has been removed.",
        "Blokada konta": "Account blocked",
        "Blokada konta do": "Account blocking to",
        "Bloki": "Blocks",
        "Blokowanie kont": "Blocking accounts",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "Error 404. The requested resource was not found.",
        "Błędne": "Incorrect",
        "Błędny": "Wrong",
        "Błędy": "Errors",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "Validation errors should be assigned to \"entry.errors.value\" as an array of messages.",
        "Brak": "Lack",
        "Brak artykułów": "No articles",
        "Brak cech w grupie": "No features in the group",
        "Brak cennika dla wybranego dostawcy.": "No price list for the selected supplier.",
        "Brak czołówki": "No www page header",
        "Brak danych": "No data",
        "Brak dodanych kolumn": "No columns added",
        "Brak dodanych plików": "No files added",
        "Brak działu nadrzędnego": "No parent section",
        "Brak elementów": "No elements",
        "Brak etykiety": "No label",
        "Brak kategorii": "No categories",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak kluczy": "No keys",
        "Brak kolekcji": "No collection",
        "Brak listy regulaminów": "No list of regulations",
        "Brak modułu": "No module",
        "Brak nowych powiadomień.": "No new notifications.",
        "Brak odpowiedzi": "No response",
        "Brak opcji": "No options",
        "Brak plików do dodania": "No files to add",
        "Brak potwierdzenia": "No confirmation",
        "Brak powiązań": "No connection",
        "Brak stron": "No pages",
        "Brak strony nadrzędnej": "No parent page",
        "Brak wersji": "No version",
        "Brak wyboru": "No choice",
        "Brak wybranych autorów": "No selected authors",
        "Brak wyników": "No results",
        "Brak zdefiniowanych ról.": "No defined roles.",
        "Brak zdefiniowanych zespołów.": "No defined teams.",
        "Bramka SMS": "SMS gateway",
        "Browse files": "Browse files",
        "Browse links": "Browse links",
        "Brutto": "Gross",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "The cache will be stored using a Redis server.",
        "Cache po stronie serwera": "Server-side caching",
        "Cache-Control": "Cache-Control",
        "Cecha została dodana.": "The feature has been added.",
        "Cecha została usunięta.": "The feature has been removed.",
        "Cecha została zaktualizowana.": "The feature has been updated.",
        "Cechy": "Features",
        "Cechy odziedziczone po kategoriach nadrzędnych": "Features inherited from parent categories",
        "Cechy w grupie": "Features in the group",
        "Cena": "Price",
        "Cena brutto": "Gross price",
        "Cena w dolarach sumy tokenów wejściowych i wyjściowych.": "The price in dollars of the sum of the input and output tokens.",
        "Cena została wyłączona z historii.": "Price has been excluded from the story.",
        "Cennik Azure OpenAI": "Azure OpenAI Pricing",
        "Cennik AzureAI": "AzureAI Price List",
        "Cennik OpenAI": "OpenAI Price List",
        "Centrum powiadomień": "Notification center",
        "Ceny dostawy": "Delivery prices",
        "Checkbox": "Checkbox",
        "Chronologia zdarzeń": "Chronology of events",
        "Ciemny": "Dark",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "CMS": "CMS",
        "Co 10 dni": "Every 10 days",
        "Co 10 minut": "Every 10 minutes",
        "Co 12 godzin": "Every 12 hours",
        "Co 15 minut": "Every 15 minutes",
        "Co 2 godziny": "Every 2 hours",
        "Co 2 minuty": "Every 2 minutes",
        "Co 2 tygodnie": "Every 2 weeks",
        "Co 20 minut": "Every 20 minutes",
        "Co 3 godziny": "Every 3 hours",
        "co 3 miesiące": "every 3 months",
        "Co 3 miesiące": "Every 3 months",
        "co 30 dni": "every 30 days",
        "Co 30 minut": "Every 30 minutes",
        "Co 4 miesiące": "Every 4 months",
        "Co 5 dni": "Every 5 days",
        "Co 5 minut": "Every 5 minutes",
        "Co 6 godzin": "Every 6 hours",
        "co 6 miesięcy": "every 6 months",
        "Co chcesz wygenerować?": "What do you want to generate?",
        "Co drugi dzień": "Every other day",
        "Co drugi miesiąc": "Every other month",
        "Co godzinę": "Every hour",
        "Co miesiąc": "Every month",
        "Co minutę": "Every minute",
        "Co pół roku": "Every half year",
        "co rok": "every year",
        "Co rok": "Every year",
        "Co tydzień": "Every week",
        "Codziennie": "Every day",
        "Connection String": "Connection String",
        "Coś poszło nie tak": "Something went wrong",
        "CRC": "CRC",
        "Cron": "Cron",
        "Cyfry": "Digits",
        "Czas": "Time",
        "Czas dostawy": "Delivery time",
        "Czas na slajd": "Time per slide",
        "Czas na stronie": "Time on page",
        "Czas na zgłoszenie reklamacji (w dniach)": "Claim time (in days)",
        "Czas na zgłoszenie zwrotu (w dniach)": "Turnaround time (in days)",
        "Czas po jakim zamówienie wygaśnie": "Time after which the order will expire",
        "Czas po jakim zamówienie zostanie anulowane": "Time after which the order will be cancelled",
        "Czas pomiędzy": "Time between",
        "Czas trwania blokady": "Account blocking time",
        "Czas uruchomienia": "Start time",
        "Czas został zaktualizowany.": "The time has been updated.",
        "Czat z asystentem": "Chat with an assistant",
        "Czerwiec": "June",
        "Częstotliwość odświeżania": "Refresh rate",
        "Członkowie zespołu": "Team members",
        "Czołówka": "Headline",
        "Czołówka została dodana.": "The lead has been added.",
        "Czołówka została usunięta.": "The lead has been removed.",
        "Czołówka została zaktualizowana.": "The lead has been updated.",
        "Cztery kolumny": "Four columns",
        "Czwartek": "Thursday",
        "Czy aby na pewno chesz zrestartować aplikacje?": "Are you sure you want to restart the applications?",
        "Czy chcesz ją przywrócić?": "Do you want to bring it back?",
        "Czy na pewno chcesz usunąć widget?": "Are you sure you want to delete the widget?",
        "Czytać mogą tylko zalogowani użytkownicy": "Only logged-in users can read it",
        "Dalej": "Next",
        "DALL-E 3": "DALL-E 3",
        "Dane": "Data",
        "Dane do faktury": "Invoice data",
        "Dane formularza są przechowywane w obiekcie Entry.": "The form data is stored in the Entry object.",
        "Dane klienta": "Customer details",
        "Dane osobowe": "Personal data",
        "Dane w tabeli": "Data in the table",
        "Dane wejściowe": "Input data",
        "Dane wyjściowe": "Output data",
        "Darmowa dostawa": "Free delivery",
        "Darmowa przesyłka od kwoty (brutto)": "Free shipping on the amount (gross)",
        "Data": "Date",
        "Data akceptacji": "Acceptance date",
        "Data automatycznej akceptacji": "Auto acceptance date",
        "Data dezaktywacji": "Deactivation date",
        "Data do": "Date to",
        "Data dodania": "Adding date",
        "Data i czas": "Date and time",
        "Data i godzina": "Date and hour",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "The date informing about date of entry into force of these regulations.",
        "Data modyfikacji": "Modification date",
        "Data modyfikacji:": "Modification date:",
        "Data od": "Date from",
        "Data odrzucenia": "Rejection date",
        "Data opłacenia": "Date of payment",
        "Data opuszczenia zespołu": "Date of leaving the team",
        "Data ostatniego użycia": "Date of last use",
        "Data otrzymania": "Receiving date",
        "Data publikacji": "Publication date",
        "Data publikacji:": "Publication date:",
        "Data rejestracji": "Registration date",
        "Data rezygnacji": "Date of resignation",
        "Data rozpoczęcia": "Start date",
        "Data subskrypcji": "Subscription date",
        "Data uruchomienia": "Start time",
        "Data uruchomienia (UTC)": "Start date (UTC)",
        "Data usunięcia": "Deletion date",
        "Data utworzenia": "Creation date",
        "Data utworzenia aranżacji": "Arrangement creation date",
        "Data utworzenia wersji": "Version creation date",
        "Data utworzenia: ": "Date of creation:",
        "Data użycia": "Use date",
        "Data wprowadzenia": "Date of introduction",
        "Data wydania": "Release date",
        "Data wygaśnięcia": "Expiration date",
        "Data wylogowania": "Logout date",
        "Data wywołania": "Call date",
        "Data zakończenia": "End date",
        "Data zalogowania": "Login date",
        "Data zapisania się": "Date of enrollment",
        "Data zapytania": "Query date",
        "Data zdarzenia": "Event date",
        "Data zgłoszenia": "Notification date",
        "Data: %0 | Status: %1": "Date: %0 | Status: %1",
        "Daty publikacji zostały zaktualizowane.": "The publication dates have been updated.",
        "Dedykowane": "Dedicated",
        "DeepL": "DeepL",
        "Definicja": "Definition of",
        "Definicja (JSON)": "Definition (JSON)",
        "Definicja formularza znajduje się w obiekcie Form.": "The form definition is in the Form object.",
        "Definicja szablonu": "Template definition",
        "DELETE: Usunięcie wpisu": "DELETE: Delete an entry",
        "Design Studio": "Design Studio",
        "Dev": "Dev",
        "Dezaktywuj": "Deactivate",
        "Dla procesu zakupowego": "For the purchasing process",
        "Długość": "Length",
        "Długość czasu przechowywania": "Length of storage time",
        "Długość trwania sesji [min": "Session duration [min",
        "Dni": "Days",
        "Dni tygodnia w których jest wysyłane zamówienie": "Days of the week on which the order is shipped",
        "do": "to",
        "Do": "To",
        "Do akceptacji": "To be accepted",
        "do czasu ręcznego odblokowania": "until manually unlocked",
        "Do poziomu": "To level",
        "Docelowa strona": "Target page",
        "Docs": "Docs",
        "Dodaj": "Add",
        "Dodaj aranżację": "Add an arrangement",
        "Dodaj asystenta": "Add an assistant",
        "Dodaj automatyzacje": "Add automation",
        "Dodaj autora": "Add author",
        "Dodaj baner": "Add banner",
        "Dodaj cechę": "Add feature",
        "Dodaj czołówkę": "Add a headlamp",
        "Dodaj dni": "Add days",
        "Dodaj do zespołu": "Add to team",
        "Dodaj do zestawu": "Add to set",
        "Dodaj dokument": "Add the document",
        "Dodaj dział": "Add section",
        "Dodaj endpoint": "Add endpoint",
        "Dodaj etykietę": "Add tag",
        "Dodaj formularz": "Add form",
        "Dodaj funkcję": "Add function",
        "Dodaj galerię": "Add gallery",
        "Dodaj gazetkę": "Add newspaper",
        "Dodaj grupę": "Add group",
        "Dodaj grupę cech": "Add feature group",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "Add one or more widgets to gain insight into your team's progress.",
        "Dodaj katalog": "Add directory",
        "Dodaj kategorie": "Add category",
        "Dodaj kategorię": "Add category",
        "Dodaj klienta": "Add client",
        "Dodaj kolejne słowo": "Add another word",
        "Dodaj kolejny element": "Add another element",
        "Dodaj kolejny powód": "Add another reason",
        "Dodaj komponent": "Add a component",
        "Dodaj kraj": "Add country",
        "Dodaj link": "Add link",
        "Dodaj moduł": "Add module",
        "Dodaj nowa kategorię": "Add a new category",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "Add a new website to start managing your pages.",
        "Dodaj nowy": "Add new",
        "Dodaj nowy folder": "Add a new folder",
        "Dodaj nowy katalog aby rozpocząć zarządzanie kategoriami.": "Add a new directory to start managing categories.",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "Add a new directory to start managing your pages.",
        "Dodaj nowy tag": "Add new tag",
        "Dodaj nowy wątek": "Add new thread",
        "Dodaj odpowiedź": "Add answer",
        "Dodaj opinię": "Add feedback",
        "Dodaj plik": "Add a file",
        "Dodaj pliki": "Add files",
        "Dodaj podsumowanie": "Add summary",
        "Dodaj pozycję": "Add item",
        "Dodaj przekierowanie": "Add redirection",
        "Dodaj pytanie": "Add question",
        "Dodaj rolę": "Add role",
        "Dodaj rotator": "Add rotator",
        "Dodaj scenariusz": "Add script",
        "Dodaj sekcję": "Add section",
        "Dodaj serwer": "Add server",
        "Dodaj shortcode": "Add shortcode",
        "Dodaj sklep": "Add store",
        "Dodaj slajd": "Add slide",
        "Dodaj slajder": "Add slider",
        "Dodaj słowo": "Add the word",
        "Dodaj sposób dostawy": "Add delivery method",
        "Dodaj sposób płatności": "Add payment method",
        "Dodaj stawkę": "Add rate",
        "Dodaj stronę": "Add page",
        "Dodaj synonimy": "Add synonyms",
        "Dodaj szablon": "Add template",
        "Dodaj token": "Add token",
        "Dodaj użytkownika": "Add user",
        "Dodaj walutę": "Add currency",
        "Dodaj wartość": "Add value",
        "Dodaj webhooka": "Add webhook",
        "Dodaj wideo": "Add video",
        "Dodaj widget": "Add widget",
        "Dodaj wiersz": "Add row",
        "Dodaj witrynę": "Add website",
        "Dodaj wpis": "Add entry",
        "Dodaj wpis w kalendarzu": "Add a calendar entry",
        "Dodaj zakres": "Add scope",
        "Dodaj zastępstwo": "Add replacement",
        "Dodaj zespół": "Add team",
        "Dodaj zestaw": "Add set",
        "Dodaj źródło": "Add source",
        "dodał": "added",
        "dodane i edytowane przeze mnie": "added and edited by me",
        "Dodane pliki z sortowaniem": "Added files with sorting",
        "Dodane przez": "Added by",
        "Dodane przez moje zespoły": "Added by my teams",
        "Dodane przeze mnie": "Added by me",
        "Dodanie": "Adding",
        "Dodanie aktualności": "Add news",
        "Dodanie ankiety": "Add surveys",
        "Dodanie aranżacji": "Adding an arrangement",
        "Dodanie artykułu": "Add article",
        "Dodanie asystenta": "Adding an assistant",
        "Dodanie autora": "Addition of author",
        "Dodanie baneru": "Adding a banner",
        "Dodanie cechy": "Adding a feature",
        "Dodanie czołówki": "Adding a headlamp",
        "Dodanie dokumentu": "Addition of document",
        "Dodanie działu": "Add section",
        "Dodanie endpointu": "Adding endpoint",
        "Dodanie etykiety": "Add tag",
        "Dodanie formularza": "Add form",
        "Dodanie funkcji": "Adding the function",
        "Dodanie galerii": "Adding a gallery",
        "Dodanie gazetki": "Adding a newspaper",
        "Dodanie grupy": "Adding a group",
        "Dodanie grupy cech": "Adding a group of features",
        "Dodanie kategorii": "Add category",
        "Dodanie klienta": "Add client",
        "Dodanie komponentu": "Adding a component",
        "Dodanie kraju": "Adding a country",
        "Dodanie linku": "Add link",
        "Dodanie linku wewnętrznego": "Adding an internal link",
        "Dodanie modułu": "Adding a module",
        "Dodanie opcji dostawy": "Adding delivery options",
        "Dodanie opcji płatności": "Adding payment options",
        "Dodanie pakietu": "Adding a package",
        "Dodanie pliku": "Adding a file",
        "Dodanie poradnika": "Add guide",
        "Dodanie regulaminu": "Add regulations",
        "Dodanie roli": "Add role",
        "Dodanie rotatora": "Adding a rotator",
        "Dodanie scenariusza": "Adding a scenario",
        "Dodanie serwera": "Add server",
        "Dodanie sklepów": "Adding stores",
        "Dodanie slajdera": "Add slider",
        "Dodanie stawki": "Adding the rate",
        "Dodanie strony": "Add page",
        "Dodanie szablonu": "Add template",
        "Dodanie top tematu": "Adding a top topic",
        "Dodanie użytkownika": "Add user",
        "Dodanie waluty": "Adding a currency",
        "Dodanie wartości": "Adding values",
        "Dodanie webhooka": "Adding a webhook",
        "Dodanie wideo": "Adding video",
        "Dodanie witryny": "Add website",
        "Dodanie wpisu do kalendarza": "Adding an entry to the calendar",
        "Dodanie zastępstwa": "Add replacement",
        "Dodanie zespołu": "Add team",
        "Dodanie zestawu regulaminów": "Add set of regulations",
        "Dodanie źródła": "Adding a source",
        "Dodanie źródła danych": "Add data source",
        "Dodano za dużo plików (maksymalnie %0).": "Added too many files (max %0).",
        "dodany": "added",
        "Dodanych plików %0 (limit wynosi %1).": "Added files %0 (limit is %1).",
        "Dodatkowe informacje": "Additional information",
        "Dodawanie": "Adding",
        "Dodawanie dokumentów": "Adding of documents",
        "Dodawanie i edycja własnych dokumentów": "Adding and editing your own documents",
        "Dodawanie wartości dwóch kolumn": "Adding values of two columns",
        "Dokument": "Document",
        "Dokument %0": "Document %0",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "The document has yet not been published anywhere.",
        "Dokument nie ma ustawionej daty publikacji.": "The document does not have a publication date set.",
        "Dokument PDF": "PDF document",
        "Dokument tekstowy": "Text document",
        "Dokument został dodany.": "Document has been added.",
        "Dokument został usunięty.": "The document has been removed.",
        "Dokument został wysłany do publikacji.": "The document has been sent for publication.",
        "Dokument został zaktualizowany.": "The document has been updated.",
        "Dokumenty": "Documents",
        "Dołącz stack trace": "Include stack trace",
        "Dołącz stronę do pliku sitemap.xml": "Add the page to the sitemap file.xml",
        "Dołączanie plików": "Attaching files",
        "Domena": "Domain",
        "Domyślna": "Default",
        "Domyślna waluta": "Default currency",
        "Domyślna wartość": "Default value",
        "Domyślna witryna": "Default site",
        "Domyślne": "Default",
        "Domyślne filtry": "Default filters",
        "Domyślne ustawienie dla witryny": "Default site setting",
        "Domyślnie ukryte": "Hidden by default",
        "Domyślnie widoczne": "By default visible",
        "Domyślny": "Default",
        "Domyślny limit (brutto)": "Default limit (gross)",
        "Domyślny tytuł aktywnej strony": "Default title of the active page",
        "Dopuść brak odpowiedzi": "Allow lack of response",
        "Dostawa w godzinach wieczornych": "Delivery in the evening",
        "Dostawa w sobotę": "Saturday delivery",
        "Dostawca": "Supplier",
        "Dostawy": "Supplies",
        "Dostawy i płatności": "",
        "Dostęp do modułu": "Access to the module",
        "Dostęp niezdefiniowany": "Undefined access",
        "Dostęp przyznany": "Access granted",
        "Dostęp zabroniony": "Access denied",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "A new update is available. Please save the work progress and click the \"Update\" button. You can also accept the update by refreshing the browser. Noo update may result in errors.",
        "Dostępna jest zapisana wersja robocza dokumentu.": "A saved draft version of the document is available.",
        "Dostępne": "Available",
        "Dostępne bloki": "Available blocks",
        "Dostępne dla": "Available for",
        "Dostępne języki": "Available languages",
        "Dostępne moduły": "Available modules",
        "Dostępne wersje językowe.": "Available language versions.",
        "Dostępny limit": "Available limit",
        "Dostępny w sekcjach": "Available in sections",
        "Dotpay": "Dotpay payment",
        "dowolnej wybranej wersji": "any selected version",
        "Dowolny": "Any",
        "Dozwolone rozszerzenia": "Allowed extensions",
        "Dozwolone rozszerzenia plików": "Allowed file extensions",
        "Dozwolone rozszerzenia: %0.": "Allowed extensions: %0.",
        "Dozwolone są tylko małe i duże litery": "Only lowercase and uppercase letters are allowed",
        "Dozwolone są tylko małe litery i znak -": "Only lowercase letters and the character - are allowed",
        "Dozwolone typy plików: %0.": "Allowed file types: %0.",
        "Drugi klucz - md5": "Second key - md5",
        "Drugi klucz (MD5)": "Second key (MD5)",
        "Drugie imię": "Middle name",
        "Drugie powiadomienie": "Second notification",
        "Dsn": "Dsn",
        "Duplikuj": "Duplicate",
        "Duże litery": "Large letters",
        "Duży": "Large",
        "Duży układ siatki": "Large grid layout",
        "Dwie kolumny": "Two columns",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "The max-age=N directive indicates that the response remains fresh until N seconds after the response is generated.",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "The no-store directive indicates that any cache of any kind should not store this response.",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "The PRIVATE directive indicates that the response can only be stored in a private cache (e.g. local browser memory).",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "The PUBLIC directive indicates that the response can be stored in a shared cache (such as a proxy).",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "The s-maxage directive is ignored by private caches and replaces the value specified by the max-age directive for shared caches.",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "The s-maxage directive indicates how long a response remains valid in a shared cache (such as a proxy).",
        "Dyrektywy zakresu": "Scope directives",
        "Dział aktywny": "Active section",
        "Dział nadrzędny": "Parent section",
        "Dział został dodany.": "The section has been added.",
        "Dział został zaktualizowany.": "The section has been updated.",
        "Działania masowe": "Mass actions",
        "Działanie modułu w oparciu o": "Module operation based on",
        "Dzielenie": "Division",
        "dzień": "day",
        "E-mail": "E-mail",
        "Edycja": "Edit",
        "Edycja aktualności": "Edit news",
        "Edycja ankiety": "Edit survey",
        "Edycja aranżacji": "Edit arrangement",
        "Edycja artykułu": "Edit article",
        "Edycja asystenta": "Edit Assistant",
        "Edycja autora": "Author's edit",
        "Edycja baneru": "Banner editing",
        "Edycja cechy": "Feature edit",
        "Edycja czołówki": "Headline Edition",
        "Edycja dokumentów": "Edit documents",
        "Edycja dokumentu": "Edit document",
        "Edycja działu": "Edit section",
        "Edycja endpointu": "Edit endpoint",
        "Edycja etykiety": "Edit label",
        "Edycja formularza": "Edit form",
        "Edycja funkcji": "Edit function",
        "Edycja galerii": "Gallery editing",
        "Edycja gazetki": "Newspaper edition",
        "Edycja grupy": "Group edit",
        "Edycja grupy cech": "Edit feature group",
        "Edycja kategorii": "Edit category",
        "Edycja klienta": "Edit client",
        "Edycja komentarza": "Edit comment",
        "Edycja komponentu": "Editing a component",
        "Edycja kraju": "Country edit",
        "Edycja linku": "Edit link",
        "Edycja linku wewnętrznego": "Edit internal link",
        "Edycja logów": "Edit logs",
        "Edycja modułu": "Module editing",
        "Edycja opcji dostawy": "Edit delivery options",
        "Edycja opcji płatności": "Edit payment options",
        "Edycja pakietu": "Editing the package",
        "Edycja pliku": "Edit file",
        "Edycja poradnika": "Edit guide",
        "Edycja regulaminu": "Edit regulations",
        "Edycja roli": "Edit role",
        "Edycja rotatora": "Edit rotator",
        "Edycja scenariusza": "Editing the scenario",
        "Edycja serwera": "Edit server",
        "Edycja sklepów": "Edit stores",
        "Edycja slajdera": "Edit slider",
        "Edycja stawki": "Edit rate",
        "Edycja strony": "Edit page",
        "Edycja szablonu": "Edit template",
        "Edycja top tematu": "Edit top topic",
        "Edycja ustawień": "Edit settings",
        "Edycja użytkownika": "Edit user",
        "Edycja w popupie": "Edit in popup",
        "Edycja waluty": "Edit currency",
        "Edycja webhooka": "Editing the webhook",
        "Edycja wideo": "Video editing",
        "Edycja witryny": "Edit site",
        "Edycja wpisu do kalendarza": "Editing a calendar entry",
        "Edycja wszystkich dokumentów": "Edit all documents",
        "Edycja zastępstwa": "Edit substitution",
        "Edycja zespołu": "Edit team",
        "Edycja zestawu regulaminów": "Editi set of regulations",
        "Edycja źródła": "Editing the source",
        "Edycja źródła danych": "Edit data source",
        "Edytor": "Editor",
        "Edytor lokalizowany": "Localized editor",
        "Edytowana wersja": "Edited version",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Only templates for enabled and supported channels can be edited.",
        "Edytuj": "Edit",
        "Edytuj blok": "Edit block",
        "Edytuj członka grupy": "Edit group member",
        "Edytuj dashboard": "Edit dashboard",
        "Edytuj dokument": "Edit document",
        "Edytuj filtr": "Edit filter",
        "Edytuj katalog": "Edit directory",
        "Edytuj kategorię": "Edit category",
        "Edytuj komentarz": "Edit comment",
        "Edytuj obszar": "Edit area",
        "Edytuj rotator": "Edit rotator",
        "Edytuj slajder": "Edit slider",
        "Edytuj stronę": "Edit page",
        "Edytuj szablon": "Edit template",
        "Edytuj tag": "Edit tag",
        "Edytuj uprawnienia": "Edit permissions",
        "Edytuj wpis": "Edit post",
        "Edytuj zestaw": "Edit set",
        "Eksport": "Exports",
        "Eksport do Excela": "Export to Excel",
        "Eksport dokumentów": "Exporting documents",
        "Eksport użytkowników": "Exporting users",
        "Element został przywrócony.": "The element has been restored.",
        "Element został usunięty.": "The element has been deleted.",
        "Email": "E-mail",
        "Email potwierdzony": "Email confirmed",
        "Email użytkownika": "User email",
        "Email z linkiem został wysłany.": "The email with the link has been sent.",
        "Endpoint został dodany.": "Endpoint has been added.",
        "Endpoint został zaktualizowany.": "Endpoint has been updated.",
        "Eskportuj": "Escort",
        "Etykieta": "Tag",
        "Etykieta została dodana.": "The label has been added.",
        "Etykieta została usunięta.": "The label has been removed.",
        "Etykieta została zaktualizowana.": "The label has been updated.",
        "Etykiety": "Tags",
        "Export": "Export",
        "Exportuj do Excela": "Export to Excel",
        "Facebook Admins": "Facebook Admins",
        "Facebook Application ID": "Facebook Application ID",
        "FavIcona": "Favicon",
        "Film": "Film",
        "Film z multimedia": "Multimedia video",
        "Film z YouTube": "YouTube video",
        "Filmy": "Videos",
        "Filtr dla synchronizacji działów": "Filter for department synchronization",
        "Filtr dla synchronizacji użytkowników": "Filter for user synchronization",
        "Filtr domyślny": "Default filter",
        "Filtr prywatny": "Private filter",
        "Filtr został usunięty": "Filter has been removed",
        "Filtr został zapisany": "Filter has been saved",
        "Filtrowanie": "Filtering",
        "Filtrowanie listy dokumentów": "Filtering the list of documents",
        "Filtry": "Filters",
        "Firebase": "Firebase",
        "Firebase config": "Firebase config",
        "Firma": "Company",
        "Folder plików": "File folder",
        "Folder został usunięty.": "The folder has been deleted.",
        "Foldery": "Folders",
        "Forma płatności": "Form of payment",
        "Format ceny": "Price format",
        "Format kodu pocztowego": "Postal code format",
        "Format kodu powinien być wyrażeniem regularnym": "The format of the code should be a regular expression",
        "Format pliku": "File format",
        "Formularz": "Modules / Contact form",
        "Formularz bazuje na nieaktualnej wersji definicji.": "The form is based on an outdated version of the definition.",
        "Formularz dynamiczny": "Dynamic form",
        "Formularz zarchiwizowany": "Archived form",
        "Formularz został dodany.": "The form has been added.",
        "Formularz został skopiowany.": "The form has been copied.",
        "Formularz został zaakceptowany.": "The form has been accepted.",
        "Formularz został zaktualizowany.": "The form has been updated.",
        "Formularze": "Forms",
        "Formuła jest nieprawidłowa": "The formula is incorrect",
        "Fraza": "Phrase",
        "Funkcja została dodana.": "The feature has been added.",
        "Funkcja została usunięta.": "The function has been removed.",
        "Funkcja została zaktualizowana.": "The feature has been updated.",
        "Funkcje": "Features",
        "Funkcje asystenta": "Assistant functions",
        "Funkcjonalności": "Features",
        "Galeria": "Gallery",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "The gallery is not yet published anywhere.",
        "Galeria nie ma ustawionej daty publikacji.": "The gallery does not have a publication date set.",
        "Galeria zdjęć": "Photo gallery",
        "Galeria zdjęć premium": "Premium photo gallery",
        "Galeria została dodana.": "The gallery has been added.",
        "Galeria została usunięta.": "The gallery has been removed.",
        "Galeria została zaktualizowana.": "The gallery has been updated.",
        "Gazetka": "Newspaper",
        "Gazetka nie jest jeszcze nigdzie opublikowana.": "The newspaper is not yet published anywhere.",
        "Gazetka nie ma ustawionej daty publikacji.": "The newspaper does not have a set publication date.",
        "Gazetka została dodana.": "The newspaper has been added.",
        "Gazetka została usunięta.": "The newspaper has been removed.",
        "Gazetka została zaktualizowana.": "The newspaper has been updated.",
        "Generator obrazów AI": "AI image generator",
        "Generowanie formularza zakończone.": "Form generation completed.",
        "Generowanie obrazów": "Image generation",
        "Generowanie obrazów zakończone.": "Image generation completed.",
        "Generowanie stron gazetek...": "Generating newspaper pages...",
        "Generuj": "Generate",
        "Generuj formularz": "Generate form",
        "Generuj metadane": "Generate metadata",
        "Generuj metadane (AI)": "Generate metadata (AI)",
        "Generuj nowe sitemapy": "Generate new sitemaps",
        "Generuj nowy obraz": "Generate new image",
        "Generuj obraz": "Generate image",
        "Generuj strony gazetki": "Generate newspaper pages",
        "Generuj wszystkie metadane": "Generate all metadata",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: List of entries (sorting and paging)",
        "GET: Pobranie danych": "GET: Downloading data",
        "GET: Pobranie wpisu": "GET: Downloading an entry",
        "GET: Schemat (definicja formularza)": "GET: schema (form definition)",
        "Godzina wysyłki zamówień": "Order shipping time",
        "Godziny": "Hours",
        "Google Nexus 10": "Google Nexus 10",
        "Google Nexus 5": "Google Nexus 5",
        "Google Nexus 7": "Google Nexus 7",
        "Google Translate V2": "Google Translate V2",
        "GPT-4 Vision": "GPT-4 Vision",
        "GPT-4o Omni": "GPT-4o Omni",
        "Grafika": "Graphics",
        "Grafika wektorowa": "Vector graphics",
        "Grudzień": "December",
        "Grupa": "Group",
        "Grupa banerów została dodana.": "The banner group has been added.",
        "Grupa banerów została usunięta.": "The banner group has been removed.",
        "Grupa banerów została zaktualizowana.": "The banner group has been updated.",
        "Grupa cech została dodana.": "The feature group has been added.",
        "Grupa cech została usunięta.": "The feature group has been removed.",
        "Grupa cech została zaktualizowana.": "The feature group has been updated.",
        "Grupy": "Groups",
        "Grupy cech": "Feature groups",
        "Harmonogram zadań": "Task scheduler",
        "Harmonogram został zmieniony": "Schedule has been changed",
        "Hasło": "Password",
        "Hasło (Klucz ukryty)": "Password (Hidden Key)",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "The password must contain at least one special character, e.g.: ~ @ $ % ^ & *",
        "Hasło użytkownika": "User password",
        "Hasło użytkownika serwisowego": "Maintenace user password",
        "Hasło zostało zmienione. Zaloguj się ponownie": "The password has been changed. Sign in again",
        "Health": "Health",
        "Hierarchia": "Hierarchy",
        "Historia": "History",
        "Historia cen": "Price history",
        "Historia logowania": "Login history",
        "Historia zadania": "Task history",
        "Historia zapytań do AI": "AI query history",
        "Host": "Host",
        "Host dodatkowy": "Secondary host",
        "Host główny": "Main host",
        "i": "and",
        "i posiadających wymagane uprawnienia": "and having the required permissions",
        "Id": "Id",
        "ID": "ID",
        "ID lub typ zadania": "Task ID or type",
        "Id modelu: %0": "Model Id: %0",
        "Id obiektu": "Facility id",
        "Id punktu płatności - posId": "Id of the payment point - posId",
        "Id punktu płatności (pos_id)": "Point-Of-Sale ID (pos_id)",
        "Id sesji": "Session Id",
        "ID sklepu": "Store ID",
        "Id wpisu": "Entry id",
        "ID zadania": "Task ID",
        "Id zapytania": "Query id",
        "Id zdarzenia": "Event Id",
        "Identyfikator": "ID",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "Store ID (default vendor id)",
        "Identyfikator sprzedawcy": "Vendor ID",
        "Identyfikator wdrożenia": "Deployment ID",
        "Identyfikator zadania": "Task identificator",
        "Ikona": "Icon",
        "Ikona wartości": "Value icon",
        "Ikona wyświetlana jest w postaci kwadratu.": "The icon is displayed in the form of a square.",
        "Ile dni przed zakończeniem subskrypcji autoodnawialnej rozpocznie się pobranie płatności": "How many days before the end of the auto-renewal subscription will start collecting payment",
        "Ile razy system ponawia płatność": "How many times the system renews the payment",
        "Ilość artykułów w kategorii": "Number of articles in the category",
        "Ilość dostępnych bloków": "Number of available blocks",
        "Ilość produktu jaka ma zostać w magazynie. W pierwszej kolejności brana po uwagę jest wartość z wariantu, następnie z produktu a na końcu z kategorii.": "The amount of product to be left in stock. The value from the variant is taken into account first, then from the product and finally from the category.",
        "Ilość wierszy": "Number of rows",
        "Ilość wyników do odrzucenia": "Number of results to be rejected",
        "Ilość wyników do pobrania": "Number of results to download",
        "Ilość wyświetlanych aktualności": "Number of news updates displayed",
        "Ilość wyświetlanych artykułów": "Number of articles displayed",
        "Ilość wyświetlanych tagów": "Number of tags displayed",
        "Ilość znaków": "Number of characters",
        "Ilość znaków odpowiedzi": "Number of response characters",
        "Imię": "First name",
        "Imię i Nazwisko": "First name and last name",
        "Imię i nazwisko/nazwa autora": "Name of author",
        "Import": "Imports",
        "Import modułu": "Module import",
        "Import użytkowników": "Importing users",
        "Importuj definicję formularza": "Import form definition",
        "Indeks": "Index",
        "Indeks został usunięty.": "The index has been removed.",
        "Indeksowanie strony": "Page indexing",
        "Informacja": "Information",
        "Informacja o błędzie": "Error information",
        "Informacja o ciasteczkach": "Information about cookies",
        "Informacje o zamówieniu": "Order information",
        "Inspekcja": "Inspection",
        "Instalacja": "Installation",
        "Instrukcja": "Instruction",
        "Instrukcja modelu (prompt).": "Model Instructions (prompt).",
        "Interakcja użytkownika (Komenatrze, Like)": "User Interaction (Comenats, Like)",
        "Interpreter kodu": "Code interpreter",
        "Interpreter kodu umożliwia asystentowi pisanie i uruchamianie kodu. To narzędzie może przetwarzać pliki z różnymi danymi i formatowaniem oraz generować pliki.": "The code interpreter allows the assistant to write and run code. This tool can process files with different data and formatting and generate files.",
        "ISBN": "ISBN",
        "Jakość": "Quality",
        "Jakość HD": "HD quality",
        "Jakość standardowa": "Standard quality",
        "Jakość wygnerowanego obrazu.": "The quality of the won image.",
        "Jasny": "Bright",
        "Jedna kolumna": "One column",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "If a particular user is not on the list, it means that basic data such as First Name and Last Name are missing. Fill in this data in the Users section.",
        "Jeśli nazwa wyświetlana nie zostanie ustawiona, to zostanie użyta nazwa kategorii.": "If the display name is not set, the category name will be used.",
        "Jeśli pole jest puste to wstawiana automatycznie.": "If the field is empty, the value is inserted automatically.",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "If the field is empty, then the default value is used. Otherwise, the default value is overwritten.",
        "Język": "Language",
        "Język domyślny": "Default language",
        "Kalendarz": "Calendar",
        "Kalendarz - Kategorie zasobów": "Calendar - Resource Categories",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "The channel is required by default. It is not possible to stop sending a notification through this channel. It is only possible to change the title and content of the message.",
        "kanał wymagany": "required channel",
        "Kanały": "Channels",
        "Kanały komunikacji": "Communication channels",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "Channels supported by the selected notification type",
        "Kanały włączone w ustawieniach aplikacji": "Channels enabled in app settings",
        "Karta": "Card",
        "Katalog": "Directory",
        "Katalog główny": "Main directory",
        "Katalog linków": "Links directory",
        "Katalog został usunięty.": "The directory has been removed.",
        "Katalog został utworzony": "The directory has been created",
        "Katalog został utworzony.": "The directory has been created.",
        "Katalogi kategorii": "",
        "Kategoria": "Category",
        "Kategoria jest wymagana": "Category is required",
        "Kategoria linku": "Link category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria opublikowana": "Category published",
        "Kategoria subskrypcji": "Subscription category",
        "Kategoria subskrypcji została dodana.": "The subscription category has been added.",
        "Kategoria subskrypcji została usunięta.": "The subscription category has been removed.",
        "Kategoria subskrypcji została zaktualizowana.": "The subscription category has been updated.",
        "Kategoria została dodana.": "The category has been added.",
        "Kategoria została usunięta.": "The category has been removed.",
        "Kategoria została zaktualizowana.": "The category has been updated.",
        "Kategorie": "Categories",
        "Kategorie linków": "Link categories",
        "Kategorię": "Category",
        "Kategorię można opublikować tylko na jednej stronie.": "A category can only be published on one page.",
        "Kategorię subskrypcji": "Subscription category",
        "Key": "Key",
        "Key pair": "Key pair",
        "Klienci": "Clients",
        "Klient aktywny": "Active client",
        "Klient został dodany.": "The client has been added.",
        "Klient został usunięty.": "The client has been deleted.",
        "Klient został zaktualizowany.": "The client has been updated.",
        "Klucz": "Key",
        "Klucz API": "API key",
        "Klucz prywatny": "Private key",
        "Klucz publiczny": "Public key",
        "Klucze": "Keys",
        "Klucze są nie prawidłowe.": "The keys are not correct.",
        "Klucze są prawidłowe.": "The keys are correct.",
        "Kobieta": "Woman",
        "Kod bannera (tutaj wklej kod HTML i JS)": "Banner code (paste HTML and JS code here)",
        "Kod Bing Webmaster": "Bing Webmaster Code",
        "Kod Google Webmaster": "Google Webmaster Code",
        "Kod GTM": "GTM code",
        "Kod HTML": "HTML code",
        "Kod ISO": "ISO code",
        "Kod pocztowy": "Postal code",
        "Kod walidacji": "Validation code",
        "Kod wertfikacyjny": "Verification code",
        "Kod weryfikacyjny jest nieprawidłowy.": "The verification code is invalid.",
        "Kod został skopiowany do schowka.": "The code was copied to the clipboard.",
        "Kod źródłowy": "Source code",
        "Kolejka": "Queue",
        "Kolejne pozycje z lewej strony": "Next items on the left",
        "Kolejne pozycje z prawej strony": "Next items on the right",
        "Kolor drugorzędny: %0": "Secondary color: %0",
        "Kolor icon na panelu z aplikacjami: %0": "The color of the icon on the app panel: %0",
        "Kolor podstawowy: %0": "Basic color: %0",
        "Kolor przewodni obrazu": "Leading image color",
        "Kolor tekstu": "Text color",
        "Kolor tekstu aktywnej pozycji menu: %0": "The text color of the active menu item: %0",
        "Kolor tła": "Background color",
        "Kolor tła panelu z aplikacjami: %0": "Background color of the application panel: %0",
        "Kolory zostały przywrócone.": "The colors have been restored.",
        "Kolory zostały zapisane.": "The colors have been recorded.",
        "Kolumna": "Column",
        "Kolumny": "Columns",
        "Komentarz": "Comments",
        "Komentarz %0": "Comment %0",
        "Komentarz do wyłączenia ceny": "Comments on price exclusion",
        "Komentarze": "Comments",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "Component whose value will be used as the name of the parent component. Only components of type ``Text`` are available.",
        "Komponent relacyjny": "Relational component",
        "Komponent został dodany.": "The component has been added.",
        "Komponent został usunięty.": "The component has been removed.",
        "Komponent został zaktualizowany.": "The component has been updated.",
        "Komponent źródłowy": "Source component",
        "Komponenty": "Components",
        "Komunikat": "Message",
        "Komunikat błędu": "Error message",
        "Komunikat mailowy": "E-mail message",
        "Komunikat walidacji": "Validation message",
        "Konfiguracja": "Settings",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "The arrangement configuration is not available because no template definition is provided.",
        "Konfiguracja asystenta ai": "Configuring the ai assistant",
        "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "Block configuration is not available because no template definition is provided.",
        "Konfiguracja bloku": "Block configuration",
        "Konfiguracja bloku została zapisana.": "The block configuration has been saved.",
        "Konfiguracja domyślna": "Default configuration",
        "Konfiguracja harmonogramu (czas UTC)": "Schedule configuration (UTC time)",
        "Konfiguracja kolumn tabeli": "Table column configuration",
        "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "Section configuration is not available because no template definition is provided.",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "Configuration of footer and logo placed in notifications sent via email channel. The footer can be configured individually for each language version, the logo is common to all.",
        "Konfiguracja zaawansowana": "Advanced configuration",
        "Konfiguracja zapytania": "Query configuration",
        "Konfiguruj kategorię": "Configure a category",
        "Konfiguruj stronę": "Configure page",
        "Konta użytkowników": "User accounts",
        "Konta użytkowników zostały odblokowane": "User accounts have been unblocked",
        "Konta użytkowników zostały przypisane do zespołu": "User accounts have been assigned to the team",
        "Konta użytkowników zostały usunięte z systemu": "User accounts have been removed from the system",
        "Konta użytkowników zostały zablokowane": "User accounts have been blocked",
        "Kontakt": "Contact",
        "Kontakty - Typ działania": "Contacts - Activity Type",
        "Kontener plików": "File container",
        "Konto aktywne": "Active account",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "The account will remain inactive until the email address is confirmed",
        "Konto publiczne": "Public account",
        "Konto z dostępem do panelu administracyjnego": "Account with access to the administration panel",
        "Konto zanonimizowane": "Anonymized account",
        "Kontrolka": "Light",
        "Kontrolka wyboru (pojedynczy wybór)": "Choice control (single choice)",
        "Kontrolka wyboru (wybór wielokrotny)": "Choice control (multiple choice)",
        "Konwertuj obrazy do formatu WebP": "Convert images to WebP format",
        "Kopiuj": "Copy",
        "Kopiuj adres": "Copy address",
        "Kopiuj definicję": "Copy definition",
        "Kopiuj pole": "Copy field",
        "Kosz": "Bin",
        "Koszt płatności netto": "Net payment cost",
        "Kraj": "Country",
        "Kraj został dodany.": "The country has been added.",
        "Kraj został zaktualizowany.": "The country has been updated.",
        "Kraje": "Countries",
        "Krok minut": "Step minutes",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "The minute step must be a number between 1 and 60.",
        "Kroki": "Steps",
        "Krótki opis": "Short description",
        "Krótki tytuł": "Short title",
        "Książka": "Book",
        "Kurs": "Course",
        "Kwiecień": "April",
        "Laptop 15,6\"": "Laptop 15.6\"",
        "Laptop 15\"": "15\" laptop",
        "Laptop 17\"": "17\" laptop",
        "LDAPS (LDAP over SSL)": "LDAPS (LDAP over SSL)",
        "Legacy": "Legacy",
        "Lewy panel": "Left panel",
        "Licencja": "License",
        "Liczba": "Number",
        "Liczba artykułów": "Number of articles",
        "Liczba całkowita": "Integer",
        "Liczba danych wejściowych podana w tokenach.": "The number of input data given in tokens.",
        "Liczba danych wyjściowych podana w tokenach.": "The number of output data given in tokens.",
        "Liczba dni przechowywania": "Number of days of storage",
        "Liczba dziesiętna": "Decimal",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "The number of slides visible to the user cannot be greater than the number of slides added in the panel.",
        "Liczba wariantów": "Number of variants",
        "Liczba wyników na stronie": "Number of results per page",
        "Liczba wyświetlanych najnowszych elementów": "Number of recent elements displayed",
        "Liczba wyświetlanych slajdów": "Number of slides displayed",
        "Liczba wyświetleń": "Number of displays",
        "Liczba zamówień": "Number of orders",
        "Liczba zgłoszeń:": "Number of requests:",
        "Lider": "Leader",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "Like to comments can only be added by logged-in users",
        "Limit": "Limit",
        "Limit API": "API limit",
        "Limit czasowy rezerwacji (w minutach)": "Booking time limit (in minutes)",
        "Limit konta OpenAI": "OpenAI account limit",
        "Limit kupiecki": "Merchant limit",
        "Limit usług AI": "AI service limit",
        "Limit zgłoszeń": "Request limit",
        "Limit znaków dla niezalogowanych": "Character limit for not logged in users is required",
        "Limit znaków dla zalogowanych": "Character limit for logged-in users is required",
        "Limity": "Limits",
        "Linia": "Line",
        "linie": "lines",
        "Link": "Link",
        "Link do strony": "Website link",
        "Link do wybranej strony serwisu": "Link to the selected page of the website",
        "Link do zewnętrznej strony": "Link to external site",
        "Link wewnętrzny został dodany.": "The internal link has been added.",
        "Link wewnętrzny został usunięty.": "The internal link has been removed.",
        "Link wewnętrzny został zaktualizowany.": "The internal link has been updated.",
        "Link wygasł": "Link expired",
        "Link z serwisu": "Link from the site",
        "Link został dodany.": "Link has been added.",
        "Link został usunięty.": "The link has been removed.",
        "Link został zaktualizowany.": "The link has been updated.",
        "Linki wewnętrzne": "Internal links",
        "Linki wewnętrzne zostały pomyślnie połączone.": "The internal links have been successfully connected.",
        "Lipiec": "July",
        "Lista artykułów": "List of articles",
        "Lista banerów": "List of banners",
        "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "List of available variables that can be used in all text fields:",
        "Lista dozwolonych / wykluczonych żądań HTTP": "List of allowed/excluded HTTP requests",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "List of effective user permissions resulting from individual permissions and roles.",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "The list of elements will be narrowed down to only those that are related to the selected values from the selected components.",
        "Lista ID": "ID list",
        "Lista indeksów": "List of indexes",
        "Lista jest pusta": "The list is empty",
        "Lista komentarzy": "Comments list",
        "Lista linków": "Links list",
        "Lista plików": "File list",
        "Lista powiadomień": "Notification list",
        "Lista regulaminów": "Regulation list",
        "Lista rozszerzeń oddzielona przecinkami.": "Comma-separated list of extensions.",
        "Lista rozwijana": "Drop-down list",
        "Lista sitemap": "List of sitemap",
        "Lista zaufanych adresów IP": "List of trusted IP addresses",
        "Listopad": "November",
        "Listy": "Letters",
        "Litery": "Letters",
        "Litery i cyfry": "Letters and numbers",
        "Logi": "Logs",
        "Logi wydajnościowe": "Performance logs",
        "Login": "Login",
        "Logo": "Logo",
        "Logowanie": "Log in",
        "Logowanie zakończyło się niepowodzeniem.": "Login failed.",
        "Logowanie zależności / żądań typu HTTP": "Logging of dependencies / HTTP type requests",
        "Loguj wybrane": "Log selected",
        "Lokalizowane": "Located",
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit.": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit.": "Lorem ipsum dolor sit, amet consectetur adipisicing elit.",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.": "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.",
        "Luty": "February",
        "Ładowanie zgłoszeń...": "Loading submissions...",
        "Łączenie treści": "Combining content",
        "Maj": "May",
        "Maksimum": "Maximum",
        "Maksymalna głębokość": "Maximum depth",
        "Maksymalna ilość plików": "Maximum number of files",
        "Maksymalna liczba produktów": "Maximum number of products",
        "Maksymalna rozdzielość %0x%1px": "Maximum resolution %0x%1px",
        "Maksymalna szerokość": "Maximum width",
        "Maksymalna szerokość strony to 1410": "The maximum page width is 1410",
        "Maksymalna waga": "Maximum weight",
        "Maksymalna waga zamówienia": "Maximum order weight",
        "Maksymalna wartość zamówienia (brutto)": "Maximum order value (gross)",
        "Maksymalna wysokość": "Maximum height",
        "Maksymalna wysokość strony to 1080": "The maximum page height is 1080",
        "Maksymalny rozmiar pliku w MB": "Maximum file size in MB",
        "Maksymalny rozmiar pliku: %0MB.": "Maximum file size: %0MB.",
        "Maksymalny rozmiar pojedynczego pliku": "Maximum size of a single file",
        "Małe litery": "Small letters",
        "Małe znaki": "Small characters",
        "Mały": "Small",
        "Mały układ siatki": "Small grid layout",
        "Mappingi": "Mappings",
        "Margines dla produktów": "Margins for products",
        "Marketing": "Marketing",
        "Marzec": "March",
        "Metadane": "Metadata",
        "Metoda": "Method",
        "Metoda autentykacji": "Authentication method",
        "Metoda musi zwracać obiekt \"entry.errors\".": "The method must return an \"entry.errors\" object.",
        "Mężczyzna": "Man",
        "Miasto": "City",
        "Miejsca po przecinku": "Decimal points",
        "Miejscowość": "Town",
        "miesiąc": "month",
        "Miesiąc": "Month",
        "Miesiące": "Months",
        "Migracje": "Migrations",
        "Miniaturka": "Thumbnail",
        "Miniaturki": "Thumbnails",
        "Minimalna długość hasła": "Minimum password length",
        "Minimalna ilość plików": "Minimum number of files",
        "Minimalna szerokość strony to 370": "The minimum page width is 370",
        "Minimalna wysokość strony to 500": "The minimum page height is 500",
        "Minimum": "Minimum",
        "Minuty": "Minutes",
        "Mnożenie": "Multiplication",
        "Mnożnik": "Multiplier",
        "Model": "Model",
        "Model danych": "Data model",
        "Moderacja włączona": "Moderation enabled",
        "Moderacja wyłączona": "Moderation disabled",
        "Moduł": "Module",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł konfigurowalny": "Configurable module",
        "Moduł płatności": "Payment module",
        "Moduł został dodany.": "The module has been added.",
        "Moduł został usunięty.": "The module has been removed.",
        "Moduł został wyeksportowany.": "The module has been exported.",
        "Moduł został zaktualizowany.": "The module has been updated.",
        "Moduły": "Modules",
        "Moduły wyszukiwarki": "Search engine modules",
        "Modyfikacja": "Modification",
        "Modyfikacja dokumentów": "Document modification",
        "Modyfikuj istniejący wątek": "Modify an existing thread",
        "Moje dokumenty": "My Documents",
        "Moje filtry": "My filters",
        "Moje konto": "My account",
        "Moje pliki": "My files",
        "Monitor kolejek": "Queue monitor",
        "Monitoring": "Monitoring",
        "Monitoruj statystyki .NET": "Monitor .NET statistics",
        "Monitoruj żądania HTTP": "Monitor HTTP requests",
        "Możesz podać nową nazwę pliku.": "You can specify a new file name.",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "The possibility of modifying this section is limited. Inactive fields are synchronized with the external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "The possibility to modify this account is limited. Inactive fields are synchronized with the external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "The ability to modify this account is limited. Inactive fields are synchronized with an external database %0.",
        "Możliwość wielokrotnego wyboru": "Multiple choice",
        "Multimedia": "Multimedia",
        "Multimedia premium": "Premium multimedia",
        "multipart/form-data": "multipart/form-data",
        "Na pewno usunąć wybrane elementy?": "Are you sure to delete the selected elements?",
        "Naciśnij enter aby usunąć": "Press enter to delete",
        "Naciśnij enter aby wybrać": "Press enter to select",
        "Nadawanie uprawnień do dokumentów": "Granting rights to documents",
        "Nadawanie uprawnień do własnych dokumentów": "Assigning rights to your own documents",
        "Nadawanie uprawnień do wszystkich dokumentów": "Granting rights to all documents",
        "Nadawca": "Sender",
        "Nagłówek": "Header",
        "Nagłówek dokumentu": "Document header",
        "Najniższa cena brutto z 30 dni przed obniżką": "The lowest gross price from 30 days before the reduction",
        "Najniższy": "Lowest",
        "Najpierw dodaj stronę do gazetki.": "First, add the site to the newspaper.",
        "Najstarsza wiadomość": "Oldest message",
        "Najwyższy": "Highest",
        "Narzędzia": "Tools",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "The tool integrates with the Firebase platform (push notifications)",
        "Narzędzie integruje się z platformą SMSAPI.pl": "The tool integrates with the SMSAPI.pl platform",
        "Następna strona": "Next page",
        "Nazwa": "Name",
        "Nazwa aktywnej strony": "Active page name",
        "Nazwa aliasu": "Alias name",
        "Nazwa aranżacji": "Arrangement name",
        "Nazwa asystenta": "Name of assistant",
        "Nazwa bazy danych": "Database name",
        "Nazwa bloku": "Block name",
        "Nazwa cechy": "Feature name",
        "Nazwa certyfikatu": "Certificate name",
        "Nazwa czołówki": "Headlamp name",
        "Nazwa działu": "Department name",
        "Nazwa etykiety": "Label name",
        "Nazwa filtra": "Filter name",
        "Nazwa formularza": "Form name",
        "Nazwa funkcji": "Function name",
        "Nazwa grupy": "Group name",
        "Nazwa grupy cech": "Name of feature group",
        "Nazwa jest wymagana": "The name is required",
        "Nazwa katalogu": "Directory name",
        "Nazwa katalogu została zmieniona.": "The directory has been renamed.",
        "Nazwa kategorii": "Category name",
        "Nazwa Kategorii": "Category Name",
        "Nazwa klienta": "Client name",
        "Nazwa kolumny": "Column name",
        "Nazwa kolumny z opisem": "Description column name",
        "Nazwa kolumny z wartością": "Column name with value",
        "Nazwa komponentu": "Component name",
        "Nazwa konta (Klucz dostępu)": "Account Name (Access Key)",
        "Nazwa linku": "Link name",
        "Nazwa modelu": "Model name",
        "Nazwa modułu": "Module name",
        "Nazwa musi mieć co najmniej 3 znaki": "The name must have at least 3 characters",
        "Nazwa musi mieć co najmniej 5 znaków": "The name must be at least 5 characters long",
        "Nazwa nadawcy": "Sender name",
        "Nazwa narzędzia": "Name of the tool",
        "Nazwa nie może być dłuższa niż 30 znaków": "The name must not be longer than 30 characters",
        "Nazwa nie może być dłuższy niż 50 znaków": "The name must not be longer than 50 characters",
        "Nazwa pakietu": "Package name",
        "Nazwa pliku": "File name",
        "Nazwa pliku została zmieniona.": "The file has been renamed.",
        "Nazwa płyty": "Disc name",
        "Nazwa pola": "Field name",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa przycisku ``Dalej``": "Button name ''Next''",
        "Nazwa przycisku ``Wstecz``": "Button name ''Back''",
        "Nazwa przycisku ``Wyślij``": "Button name ''Send''",
        "Nazwa roli": "Role name",
        "Nazwa rotatora": "Rotator name",
        "Nazwa sekcji": "Section name",
        "Nazwa sekcji w menu": "Name of the section in the menu",
        "Nazwa sekcji...": "Section name...",
        "Nazwa serwera": "Server name",
        "Nazwa slajdera": "Slider name",
        "Nazwa slajdu": "Slide name",
        "Nazwa sposobu dostawy": "Name of delivery method",
        "Nazwa sposobu płatności": "Name of payment method",
        "Nazwa strony": "Page name",
        "Nazwa szablonu": "Template name",
        "Nazwa typu": "Type name",
        "Nazwa urządzenia": "Device name",
        "Nazwa użytkownika": "User name",
        "Nazwa użytkownika serwisowego": "Maintenance user name",
        "Nazwa w panelu": "Name in panel",
        "Nazwa wątku": "Thread name",
        "Nazwa webhooka": "Webhook name",
        "Nazwa wewnętrzna": "Internal name",
        "Nazwa witryny": "Site name",
        "Nazwa wpisu do kalendarza": "Name of the calendar entry",
        "Nazwa wyświetlana": "Display name",
        "Nazwa wyświetlana:": "Display Name:",
        "Nazwa zadania": "Task name",
        "Nazwa zasobu": "Name of the resource",
        "Nazwa zespołu": "Team name",
        "Nazwa zestawu": "Set name",
        "Nazwa źródła": "Source name",
        "Nazwa źródła danych": "Data source name",
        "Nazwa:": "Name:",
        "Nazwisko": "Last name",
        "Nazwy wartości": "Names of values",
        "Netto": "Net",
        "Nie": "No",
        "Nie loguj wybranych": "Do not log selected",
        "Nie ma jeszcze żadnych kategorii.": "There are no categories yet.",
        "Nie masz uprawnień do modyfikacji aranżacji.": "You do not have permission to modify the arrangement.",
        "Nie masz uprawnień do panelu administracyjnego.": "You do not have permission to access the administration panel.",
        "Nie masz uprawnień do publikacji aranżacji.": "You don't have permission to publish the arrangement.",
        "Nie masz uprawnień do tego dokumentu": "You don't have the authority for this document",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "You do not have permissions for this view. The state of the view may have changed, refresh and check or try again later.",
        "Nie możesz dodać tego samego widgetu dwa razy": "You can't add the same widget twice",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "You cannot modify the profile of the replaced user.",
        "Nie możesz modyfikować uprawnień": "You cannot modify permissions",
        "Nie można już edytować tego linku wewnętrznego, ponieważ jest on aktualnie używany.": "This internal link can no longer be edited, as it is currently in use.",
        "Nie można usunąć swojego konta.": "You can't delete your account.",
        "Nie podano wymaganej ilości znaków: %0.": "The required number of characters was not given: %0.",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "Required number of characters not provided: %0. (%1)",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "Do not show a short description of the page in search results (NoSnippet)",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "Do not show a link to the archive of the page (NoArchive)",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "Do not show the page as an image source in search results (NoImageIndex)",
        "Nie posiadasz uprawnień do edycji tego artykułu.": "You do not have permission to edit this article.",
        "Nie pozwól zamówić": "Don't let the order",
        "Nie udało się pobrać kategorii": "Failed to download category",
        "Nie udało się pobrać listy aranżacji": "Failed to download the arrangement list",
        "Nie udało się pobrać listy bloków": "Failed to download block list",
        "Nie udało się pobrać listy działów": "Failed to download the sections list",
        "Nie udało się pobrać listy etykiet": "Failed to download label list",
        "Nie udało się pobrać listy filtrów": "Failed to download filter list",
        "Nie udało się pobrać listy kanałów": "Failed to download channel list",
        "Nie udało się pobrać listy kategorii": "Failed to download category list",
        "Nie udało się pobrać listy kolejek": "Failed to download queue list",
        "Nie udało się pobrać listy modułów": "Failed to download module list",
        "Nie udało się pobrać listy modułów wyszukiwarki": "Failed to download list of search engine modules",
        "Nie udało się pobrać listy powiadomień": "Failed to download notification list",
        "Nie udało się pobrać listy regulaminów": "Failed to download the list of regulations",
        "Nie udało się pobrać listy ról": "Failed to download role list",
        "Nie udało się pobrać listy serwerów baz danych": "Failed to retrieve the database server list",
        "Nie udało się pobrać listy serwerów plików": "Failed to download the file server list",
        "Nie udało się pobrać listy stron": "Failed to download the pages list",
        "Nie udało się pobrać listy szablonów": "Failed to download template list",
        "Nie udało się pobrać listy typów modeli": "Failed to download the list of model types",
        "Nie udało się pobrać listy wydziałów": "Failed to download the list of sections",
        "Nie udało się pobrać listy zespołów": "Failed to download the list of teams",
        "Nie udało się pobrać obrazu.": "The image could not be downloaded.",
        "Nie udało się pobrać powiadomień.": "Failed to download notifications.",
        "Nie udało się pobrać ustawień kont użytkowników": "Failed to download user account settings",
        "Nie udało się pobrać widgetu/ów": "Failed to download widget(s)",
        "Nie udało się usunąć szablonu": "Failed to delete template",
        "Nie udało się wczytać podglądu strony.": "Failed to load the website preview.",
        "Nie udało się wygenerować formularza": "Failed to generate form",
        "Nie udało się wykonać akcji": "Failed to perform the action",
        "Nie udało się wysłać pliku": "Failed to send file",
        "Nie udało się załadować widgetu AI.": "AI widget failed to load.",
        "Nie udało się zapisać filtra": "Failed to save filter",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Not all selected items have been transfered. You do not have the required permissions or, if you are moving directories, the destination directory is a subdirectory of the source directory. Directories and files that could not have been transfered remain in the Selected tab.",
        "Nie wybrano authora.": "No author has been selected.",
        "Nie wybrano strony": "No page has been selected",
        "Nie wybrano żadnego użytkownika.": "No user has been selected.",
        "Nie wybrano żadnej kategorii": "No category was selected",
        "Nie wymaga uwierzytelniania": "No authentication required",
        "nie wymuszaj zmiany hasła": "do not force password change",
        "Nie zdefiniowano żadnych ról.": "No roles are defined.",
        "Nie zdefiniowano żadnych sekcji.": "No sections are defined.",
        "Nie znaleziono dostępnych widgetów": "No available widgets found",
        "Nie znaleziono filtrów.": "No filters found.",
        "Nie znaleziono formularza.": "The form was not found.",
        "Nie znaleziono kolumn.": "No columns found.",
        "Nie znaleziono pasującego widgetu": "No matching widget found",
        "Nie znaleziono pasujących elementów.": "No matching items found.",
        "Nie znaleziono żadnego pola.": "No field was found.",
        "Nie znaleziono żadnych folderów.": "No folders were found.",
        "Nie znaleziono żadnych plików": "No files found",
        "Nie znaleziono żadnych użytkowników.": "No users were found.",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nieaktywne": "Inactive",
        "Nieaktywni": "Inactive",
        "Nieaktywny": "Inactive",
        "niedozwolone rozszerzenie pliku (%0)": "file extension not allowed (%0)",
        "Niedozwolone słowa": "Unpermitted words",
        "niedozwolony typ pliku (%0)": "file type not allowed (%0)",
        "Niedziela": "Sunday",
        "Niepoprawne wyrażenie regularne": "Incorrect regular expression",
        "Niepotwierdzeni": "Unconfirmed",
        "Nieprawidłowa definicja": "Incorrect definition",
        "Nieprawidłowy adres email": "Invalid email address",
        "Nieprawidłowy adres URL": "Invalid URL",
        "Nieprzeczytane": "Unread",
        "Niestandardowy adres": "Non-standard address",
        "Niestandardowy adres strony": "Non-standard page address",
        "Niestandardowy błąd": "Non-standard error",
        "Niestandardowy nagłówek": "Custom header",
        "Nieudane": "Failed",
        "Nieudane logowania": "Failed logins",
        "Niewidoczne": "Not visible",
        "Nieznane narzędzie": "Unknown tool",
        "Nieznany model": "Unknown model",
        "Nieznany typ pliku": "Unknown file type",
        "Nieznany widget": "Unknown widget",
        "Nigdy": "Never",
        "Nikomu nie przydzielono uprawnień": "No one has been granted permissions",
        "NIP": "Tax ID Number",
        "Niski": "Low",
        "Niżej": "Below",
        "no-store (wyłącza cache)": "no-store (disables cache)",
        "Nofollow": "Nofollow",
        "Nowa cena brutto": "New gross price",
        "Nowa cena do": "New price to",
        "Nowa cena od": "The new price from",
        "Nowa data": "New date",
        "Nowe hasło": "New password",
        "Nowe sitemapy zostały wygenerowane.": "New sitemaps have been generated.",
        "np. (&(objectClass=organizationalUnit))": "e.g. (&(objectClass=organizationalUnit))",
        "np. (&(objectClass=user)": "e.g. (&(objectClass=user)",
        "np. pl-PL": "i.e., pl-PL",
        "Number": "Number",
        "Numer": "Number",
        "Numer aktywnej strony": "Active page number",
        "Numer budynku": "Building number",
        "Numer domu": "House no",
        "Numer domu/mieszkania": "House/apartment number",
        "Numer kierunkowy": "Area code",
        "Numer konta": "Account number",
        "Numer mieszkania": "Flat no",
        "Numer sesji": "Session number",
        "Numer telefonu": "Phone number",
        "OAuth2 dla Exchange Online": "OAuth2 for Exchange Online",
        "Obiekt %0 został %1": "Object %0 zostood %1",
        "Obok siebie": "Next to each other",
        "Obraz": "Image",
        "Obraz został pomyślnie opisany": "The image has been successfully described",
        "Obraz został wycięty.": "The image has been cut out.",
        "Obraz został wygenerowany.": "The image has been generated.",
        "Obsługiwane formaty plików: txt, md, pdf, docx.": "Supported file formats: txt, md, pdf, docx.",
        "Oczekujący na akceptację": "Awaiting approval",
        "Oczekuje na płatność": "Awaiting payment",
        "Oczekuje na potwierdzenie": "Awaiting confirmation",
        "Oczekuje na wysłanie": "To be shipped",
        "Oczekuje na zatwierdzenie": "Awaiting approval",
        "od": "from",
        "Od": "From",
        "od %0": "from %0",
        "Od poziomu": "From level",
        "Odbiorca": "Recipient",
        "Odbiorca (firma)": "Recipient (company)",
        "Odblokuj": "Unblock",
        "Odejmowanie": "Subtraction",
        "Odnośnik URL": "URL reference",
        "Odpowiedzi": "Responses",
        "Odpowiedzi: %0 na %1": "Answers: %0 na %1",
        "Odpowiedź": "Answer",
        "Odpowiedź dowolna": "Any answer",
        "Odrzucone": "Rejected",
        "Odrzucone zgody": "Rejected consents",
        "Odrzucony po zgłoszeniach": "Rejected after requests",
        "Odrzuć": "Reject",
        "Odstęp": "Space",
        "Odśwież": "Refresh",
        "Odznacz": "Unselect",
        "Odznacz wszystkie": "Unselect all",
        "Ok": "Ok",
        "Okładka": "Cover",
        "Okładka do wideo premium": "Coverage for premium video",
        "Określa miejsce, w którym znajdzie się powiązany artykuł": "Determines where the related article will be located",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "Specifies where you want to add additional items to the path.",
        "Omnitool": "Omnitool",
        "Opcja dodatkowa": "Additional option",
        "Opcje": "Options",
        "Open Graph": "Open Graph",
        "OpenAI": "OpenAI",
        "Operacje": "Operations",
        "Operator płatności": "Payment operator",
        "Opinia": "Opinion",
        "Opis": "Description",
        "Opis błędu": "Error description",
        "Opis funkcji": "Functional description",
        "Opis obrazu": "Image description",
        "Opis przerwy technicznej": "Description of the technical break",
        "Opis sekcji": "Section description",
        "Opis wartości": "Value description",
        "Opis witryny": "Site description",
        "Opis zespołu": "Team description",
        "Opis źródła": "Source description",
        "Opisy": "Descriptions",
        "Opisz jaki formularz chcesz wygenerować": "Describe what form you want to generate",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Opublikowana": "Published",
        "Opublikowane": "Published",
        "Opublikowane języki": "Published languages",
        "Opublikowane wersje językowe.": "Published language versions.",
        "Opublikowany na stronach": "Published on pages",
        "Opublikuj": "Publish",
        "Opublikuj autora": "Publish author",
        "Oraz hasło": "And the password",
        "Oraz nowe hasło": "And a new password",
        "Organizacja": "Organization",
        "Organizacja została usunięta.": "The organization has been removed.",
        "Osoba zastępowana": "Person being substituted",
        "Osoba zastępująca": "Substitute",
        "Ostatnia aktualizacja:": "Last updated:",
        "Ostatnia aktywność": "Recent activity",
        "Ostatnia strona": "Last page",
        "Ostrzeżenia": "Warnings",
        "Ostrzeżenie": "Warning",
        "Oś czasu": "Timeline",
        "Otwieraj w nowym oknie": "Open in new window",
        "Otwórz": "Open",
        "Otwórz stronę w nowym oknie": "Open the page in a new window",
        "Oznacz": "Mark",
        "Oznacz jako nieprzeczytane": "Mark as unread",
        "Oznacz jako opłacone": "Mark as paid",
        "Oznacz jako przeczytane": "Mark as read",
        "Oznacz powiadomienia": "Mark notifications",
        "Oznacz wszystkie jako przeczytane": "Mark all as read",
        "Oznacz wybrane jako nieprzeczytane": "Mark selected as unread",
        "Oznacz wybrane jako przeczytane": "Mark selected as read",
        "Pakiet": "Package",
        "Pakiet aktywny": "Active package",
        "Pakiet autoodnawialny": "Auto-renewable package",
        "Pakiet został dodany.": "The package has been added.",
        "Pakiet został zaktualizowany.": "The package has been updated.",
        "Pakiety": "Packages",
        "Paleta kolorów": "Color palette",
        "Państwo aktywne": "Active state",
        "Parametry funkcji": "Function parameters",
        "Parametry, wymagane do wykonania zapytania:": "Parameters required to execute the request:",
        "Pasek": "Bar",
        "Pasek postępu": "Progress bar",
        "PayPal": "PayPal",
        "PayU": "PayU",
        "Październik": "October",
        "Pełna strona": "Full page",
        "Pełna treść:": "Full content:",
        "Pełny": "Full",
        "Pełny adres aktywnej strony": "Full address of the active site",
        "Pełny adres wraz z \"http(s)://\".": "Full address including \"http(s)://\".",
        "Pełny ekran": "Full screen",
        "Piątek": "Friday",
        "Pierwiastkowanie wartości kolumny": "Priming of column values",
        "Pierwsza strona": "First page",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "The first page in the list is identified by the system as CANONICAL, which means it tells search engine robots which of the duplicate pages is the one with the original content.",
        "Pierwsze powiadomienie": "First notification",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "The first photo in the gallery is the main photo",
        "Pigułki": "Pills",
        "Piktogram": "Pictogram",
        "PIN": "PIN",
        "Piosenka": "Song",
        "Pisać mogą tylko zalogowani użytkownicy": "Only logged-in users can write",
        "Plik": "File",
        "Plik audio": "Audio file",
        "Plik binarny": "Binary file",
        "Plik CSS": "CSS file",
        "Plik CSV": "CSV file",
        "Plik DOC": "DOC file",
        "Plik DOCX": "DOCX file",
        "Plik gazetki (PDF)": "Newspaper file (PDF)",
        "Plik gazetki do pobrania (PDF)": "Newspaper file to download (PDF)",
        "Plik GIF": "GIF file",
        "Plik graficzny": "Image file",
        "Plik HTML": "HTML file",
        "Plik jest wysyłany": "The file is being sent",
        "Plik JPEG": "JPEG file",
        "Plik JPG": "JPG file",
        "Plik MP4": "MP4 file",
        "Plik PNG": "PNG file",
        "Plik skompresowany": "Compressed file",
        "Plik wideo": "Video file",
        "Plik ZIP": "ZIP file",
        "Plik został dodany.": "The file has been added.",
        "Plik został usunięty.": "The file has been deleted.",
        "Plik został wysłany": "The file has been sent",
        "Plik:": "File:",
        "Pliki": "Files",
        "Pliki asystenta": "Assistant files",
        "Pliki do dodania": "Files to add",
        "Pliki do wysłania: %0": "Files to send: %0",
        "Pliki prywatne": "Private files",
        "Pliki publiczne": "Public files",
        "Pliki współdzielone": "Shared files",
        "Pliki: %0": "Files: %0",
        "Płatności": "Payments",
        "Płeć": "Gender",
        "Płyta z muzyką": "Music CD",
        "po %0 nieudanych próbach logowania": "after %0 unsuccessful login attempts",
        "Po aktywacji wejście na dowolną stronę frontową przez użytkownika w obrębie witryny wyświetli informację o trwającej przerwie technicznej. Witryna podczas przerwy technicznej dla użytkowników z uprawnieniami administratora jest zawsze dostępna.": "Once activated, accessing any front page by a user within the site will display information about the ongoing technical break. The site during a technical break for users with administrator privileges is always accessible.",
        "Po jednym synonimie w wierszu": "One synonym per line",
        "Po upływie tego czasu (liczonego od czasu utworzenia rezerwacji) rezerwacja przestanie obowiązywać (0 - brak limitu).": "After this time (calculated from the time of creation of the reservation), the reservation will cease to be valid (0 - no limit).",
        "Po upływie tego czasu nie bedzie można złożyć reklamacji. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane. ": "After this time, it will not be possible to make a complaint. Time is calculated from the moment the order status changes to Completed.",
        "Po upływie tego czasu nie bedzie można złożyć zwrotu. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane.": "After this time, you will not be able to submit a return. Time is calculated from the moment the order status changes to Completed.",
        "Po wybraniu artykułu \"Opinia\", etykieta zostanie ustawiona automatycznie jako \"OPINIA\".": "When you select an \"Opinion\" article, the label will be automatically set as \"OPINION\".",
        "Po wybraniu opcji \"Artykuł sponsorowany\", etykieta zostanie ustawiona automatycznie jako \"ARTYKUŁ SPONSOROWANY\". Obie te etykiety nie mogą występować razem.": "When \"Sponsored article\" is selected, the label will be automatically set as \"SPONSORED ARTICLE\". The two labels cannot appear together.",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "If you select this option, user accounts will be deleted from the system. Do you want to continue?",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "When you select this option, individual and role permissions will not be considered.",
        "Po zmianie krótkiego tytułu zmieni się również adres URL.": "When you change the short title, the URL will also change.",
        "Pobierz": "Download",
        "Pobierz wyniki": "Download the results",
        "Pobranie": "Download",
        "Początkowa ilość wierszy": "Initial number of rows",
        "Poczta": "Mail",
        "Podaj adres url...": "Enter the url...",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "Provide Facebook user IDs, separated by commas, so they can access to their statistics (Facebook Insights).",
        "Podaj kod weryfikacyjny": "Enter verification code",
        "Podaj nową nazwę": "Enter a new name",
        "Podaj swój adres email": "Enter your email address",
        "Podana nazwa jest zajęta.": "The name you entered is already taken.",
        "Podana wartość jest nieprawidłowa.": "The provided value is not valid.",
        "Podanie nazwy jest wymagane.": "Name is required.",
        "Podano adres": "The address provided is",
        "Podano nieprawidłowe dane": "Invalid data provided",
        "Podano nieprawidłowe dane.": "Invalid data provided.",
        "Podano nieprawidłowe dane. (%0)": "Incorrect data was provided. (%0)",
        "Podatki": "Taxes",
        "Podążanie za linkami": "Links following",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "During the first startup, it is required to create a master administrator account.",
        "Podgląd": "Preview",
        "Podgląd artykułu": "Article preview",
        "Podgląd formularza": "Form preview",
        "Podgląd strony": "Page preview",
        "Podgląd tabeli": "Table preview",
        "Podkreślenie": "Highlight",
        "Podłącz linki wewnętrzne": "Connect internal links",
        "Podpis": "Signature",
        "Podstawowe": "Basic",
        "Podstawowe operacje na datach": "Basic date operations",
        "Podstawowe operacje na liczbach": "Basic digits operations",
        "Podstawowe operacje tekstowe": "Basic text operations",
        "Podstawowe operacje warunkowe": "Basic conditional operations",
        "Podziedziałek - Piątek": "Monday- Friday",
        "Pojedynczy artykuł (strona opisowa)": "Single article (descriptive page)",
        "Pojedynczy wybór": "Single choice",
        "Pokaż etykietę": "Show tag",
        "Pokaż historię": "Show history",
        "Pokaż kafelki do ostatniego poziomu": "Show tiles up to the last level",
        "Pokaż kafelki do wybranego poziomu": "Show tiles up to the selected level",
        "Pokaż numery stron": "Show page numbers",
        "Pokaż przycisk ``Wyślij``": "Show ''Send'' button",
        "Pokaż szczegóły": "Show details",
        "Pokaż tylko moje dokumenty": "Show my documents only",
        "Pokaż tytuł formularza": "Show form title",
        "Pokaż tytuł sekcji": "Show section title",
        "Pokaż tytuł strony": "Show page title",
        "Pokaż tytuły stron": "Show page titles",
        "Pokaż w koncie użytkownika": "Show in user account",
        "Pokaż więcej": "Show more",
        "pokaż więcej...": "show more...",
        "Pole \"%0\" jest wymagane.": "Field ''%0'' is required.",
        "Pole \"%0\" jest wymagane. (%1)": "The \"%0\" field is required. (%1)",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Field ''%0'' does not contain a valid email address.",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Field ''%0'' does not contain a valid URL address.",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "The \"%0\" field contains an impermissible value.",
        "Pole \"Drugie imię\" jest wymagane.": "''Middle name'' is required.",
        "Pole \"Email\" jest wymagane.": "The \"Email\" field is required.",
        "Pole \"Imię\" jest wymagane.": "''Name'' is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "The \"User name\" field is required.",
        "Pole \"Nazwisko\" jest wymagane.": "''Surname'' is required.",
        "Pole \"Tytuł\" jest wymagane.": "''Title'' is required.",
        "Pole jest wymagane": "The field is required",
        "Pole może zawierać jedynie cyfry.": "Field can only contain numbers.",
        "Pole może zawierać jedynie cyfry. (%0)": "The field can only contain digits. (%0)",
        "Pole może zawierać jedynie litery i cyfry.": "This field can contain only letters and numbers.",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "The field can only contain letters and numbers. (%0)",
        "Pole może zawierać jedynie litery.": "This field can only contain letters.",
        "Pole może zawierać jedynie litery. (%0)": "The field can only contain letters. (%0)",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "The field can only contain the body of the method that validates the data in the form of native JavaScript code.",
        "Pole nie może zawierać spacji": "The field must not contain spaces",
        "Pole skopiowane": "Field copied",
        "Pole tekstowe": "Text field",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "Field type \"%0\" is not allowed in this form.",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "The field requires at least one special character.",
        "Pole wymaga podania przynajmniej jednej cyfry.": "The field requires at least one digit.",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "The field requires at least one capital letter.",
        "Pole wymaga podania przynajmniej jednej małej litery.": "The field requires at least one lowercase letter.",
        "Pole wymagane": "Field required",
        "Pole zawiera": "Field contains",
        "Polecane artykuły": "Featured Articles",
        "Polityka prywatności": "Privacy policy",
        "Polski": "Polish",
        "Pomoc": "Help",
        "Poniedziałek": "Monday",
        "Poprawne": "Correct",
        "Poprawny": "Correct",
        "Poprzednia strona": "Previous page",
        "Popularność": "Popularity",
        "Porównaj %0": "Compare %0",
        "Porównaj z edytowaną wersją": "Compare with edited version",
        "Porównania": "Comparison",
        "Porównanie": "Comparison",
        "Porównywana wersja": "Compared version",
        "Port": "Port",
        "Posiada załączniki": "Containing attachments",
        "POST: Lista wpisów (dowolne wyszukiwanie)": "POST: List of entries (any search)",
        "POST: Upload załączników": "POST: Upload attachments",
        "POST: Utworzenie wpisu": "POST: Create an entry",
        "POST: Zapisanie zmian": "POST: Save changes",
        "Potwierdzenia": "Confirmations",
        "Potwierdzenie mailowe": "Email confirmation",
        "Potwierdzenie mailowe i akceptacja administratora": "Email confirmation and administrator approval",
        "Potwierdzenie przywrócenia": "Confirmation of restoration",
        "Potwierdzenie usunięcia": "Deletion confirmation",
        "Potwierdzenie włączenia": "Confirmation of inclusion",
        "Potwierdzenie wylogowania użytkownika": "Confirmation of user logout",
        "Potwierdzenie wyłączenia": "Confirmation of shutdown",
        "Potwierdzenie wysłania": "Confirmation of dispatch",
        "Potwierdzenie zatwierdzenia": "Approval confirmation",
        "Potwierdzenie zmiany statusu": "Confirmation of status change",
        "Potwierdzone": "Confirmed",
        "Potwierdź": "Confirm",
        "Potwierdź akceptację": "Confirm acceptance",
        "Potwierdź przywrócenie wersji roboczej": "Confirm restoration of draft version",
        "Potwierdź publikację wersji": "Confirm version publication",
        "Potwierdź usunięcie": "Confirm deletion",
        "Potwierdź usunięcie wybranej wersji aranżacji": "Confirm deletion of selected arrangement version",
        "Potwierdź wyłączenie publikacji": "Confirm that you want to disable publication",
        "Powiadomienia": "Notifications",
        "Powiadomienia mailowe": "Email notifications",
        "Powiadomienia zostały skonfigurowane.": "Notifications have been configured.",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Notification is required by default. You cannot stop this notification to appear.",
        "Powiadomienie testowe zostało wysłane.": "Test notification has been sent.",
        "Powiązana galeria": "Related gallery",
        "Powiązana kategoria": "Related category",
        "Powiązane artykuły": "Related articles",
        "Powiązane galerie": "Related galleries",
        "Powiązane kategorię": "Related Categories",
        "Powiązane wideo": "Related video",
        "Powiązany artykuł": "Related article",
        "Powiązany autor": "Related author",
        "Powiększ": "Zoom in",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "A PRIVATE directive should be added for user-personalized content, especially for responses received after login and with permissions.",
        "Powód": "Reason",
        "powrót": "return",
        "Powrót": "Back",
        "Powtórz hasło": "Repeat password",
        "Powtórzone": "Repeated",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "The above objects contain only properties and are devoid of all methods.",
        "Poziom dostępu do webhooka": "Webhook access level",
        "Poziom dostępu użytkownika": "User access level",
        "Pozostałe": "Others",
        "Pozostałe ustawienia": "Other settings",
        "Pozostało %0 znaków.": "There are %0 characters left.",
        "Pozwól na dodawanie wierszy": "Allow rows to be added",
        "Pozwól zamawiać": "Allow ordering",
        "Pozycja": "Position",
        "pół roku": "six months",
        "Prawy panel": "Right panel",
        "Predefiniowane tła panelu z aplikacjami": "Predefined backgrounds of the panel with applications",
        "Predefiniowane zestawy kolorów": "Predefined color sets",
        "Premiera": "Premiere",
        "Premium": "Premium",
        "Premium otwarty": "Premium open",
        "Priorytet": "Priority",
        "private (tylko cache przeglądarki)": "private (browser cache only)",
        "Procent": "Percentage",
        "Produkcyjne": "Manufacturing",
        "Profil użytkownika": "Profile",
        "Profil został zaktualizowany.": "The profile has been updated.",
        "Projekt": "Project",
        "Prometheus": "Prometheus",
        "Proporcje obrazu": "Image aspect ratio",
        "Proste uprawnienia": "Simple powers",
        "Protokół OAuth - client_id": "OAuth protocol - client_id",
        "Protokół OAuth - client_secret": "OAuth protocol - client_secret",
        "Protokół OAuth - clientId": "OAuth protocol - clientId",
        "Protokół OAuth - clientSecret": "OAuth protocol - clientSecret",
        "Próbkowanie": "Sampling",
        "Prywatne": "Private",
        "Przebudowanie indeksów": "Rebuilding the indexes",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "Rebuilding indexesnnOperation can take from a few seconds to several hours depending on the size of the indexes.nnUse only if you need to apply changes made to the dictionaries of synonyms or excluded words.",
        "Przeciągnij do innej sekcji": "Drag to another section",
        "Przeciągnij do wybranej sekcji": "Drag to the desired section",
        "Przeciągnij i upuść aby posortować pliki": "Drag and drop to sort files",
        "Przeczytane": "Read",
        "Przedrostek": "Prefix",
        "Przedtytuł": "Pre-title",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "The browser you are using does not support PUSH notifications",
        "Przeindeksowanie danych": "Data over-indexing",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "Over-indexing datannOperation can take from a few seconds to a few hours depending on the amount of data in the database.nnUse only if you notice missing data in the indexes.",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Go to configuration to enable tools",
        "Przekierowania": "Redirects",
        "Przekierowanie aktywne": "Redirection active",
        "Przekierowanie zostało dodane.": "Redirection has been added.",
        "Przekierowanie zostało usunięte.": "The redirect has been removed.",
        "Przekierowanie zostało zaktualizowane.": "The redirection has been updated.",
        "Przekroczono dozwoloną ilość znaków: %0.": "Allowed number of characters exceeded: %0.",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "The allowed number of characters has been exceeded: %0. (%1)",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "exceeded the allowed file size (%0 MB)",
        "Przelew tradycyjny": "Traditional bank transfer",
        "Przelewy24": "Przelewy24",
        "Przełącznik": "Switcher",
        "Przeniesienie wybranych elementów": "Transfer selected items",
        "przeniesiony do kosza": "transferred to basket",
        "Przenieś": "Move",
        "Przenieś do sekcji": "Move to section",
        "Przenieś niżej": "Move lower",
        "Przenieś wyżej": "Move higher",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "Move${selected.length > 1 ? ' selected : ' }",
        "przeniósł do kosza": "transferred to trash",
        "Przepisz limit konta oraz aktualne stawki za 1000 tokenów ze strony OpenAI.": "Rewrite the account limit and current rates for 1,000 tokens from the OpenAI website.",
        "Przepnij alias": "Rewrite alias",
        "Przerwa techniczna": "Technical break",
        "Przesuń do góry": "Move up",
        "Przesuń na dół": "Move down",
        "Przesuń w dół": "Move down",
        "Przesyłanie plików powiodło się.": "File transfer was successful.",
        "Przetestuj": "Test",
        "Przetestuj poprawność zapisanych kluczy": "Test the correctness of the stored keys",
        "Przetestuj ustawienia poczty": "Test your mail settings",
        "Przetestuj ustawienia Sms": "Test your SMS settings",
        "Przetwarzane": "Processing",
        "Przybornik": "Kit",
        "Przykład:": "Example:",
        "Przykład: ^\\d{5}$": "Example: ^\\d{5}$",
        "Przykład: 00000": "Example: 00000",
        "Przykład: domena\\użytkownik": "Example: domain user",
        "Przykład: użytkownik@domena": "Example: user@domain",
        "Przykładowa struktura danych": "Example data structure",
        "Przykłady": "Examples",
        "Przykłady konfiguracji": "Examples of configurations",
        "Przypisanie do zespołu": "Assignment to a team",
        "Przypisanie ról": "Assignment of roles",
        "Przyrostek": "Suffix",
        "Przywrócenie": "Restore",
        "przywrócił z kosza": "brought back from the garbage can",
        "przywrócony z kosza": "restored from the garbage can",
        "Przywróć": "Reload",
        "Przywróć domyślne": "Restore defaults",
        "Przywróć filtr": "Restore filter",
        "Przywróć${checkedItems.length > 1 ? ' zaznaczone' : ''}": "Restore${checkedItems.length > 1 ? ' selected : ' }",
        "Przyznaj dostęp": "Grant access",
        "Pseudonim": "Pseudonym",
        "public (cache przeglądarki i proxy)": "public (browser cache and proxy)",
        "Publiczne": "Public",
        "Publiczne ID:": "Public ID:",
        "Publikacja": "Publication",
        "Publikacja aranżacji została wyłączona.": "The publication of the arrangement has been disabled.",
        "Publikacja artykułu": "Article publication",
        "Publikacja galerii przez użytkownika": "Publication of galleries by user",
        "Publikacja priorytetowa": "Priority publication",
        "Publikacja zarchiwizowana": "Archived publication",
        "Publikacja została dodana.": "The publication has been added.",
        "Publikacja została usunięta.": "The publication has been deleted.",
        "Publikuj do": "Publish to",
        "Publikuj na stronie": "Publish to page",
        "Publikuj na wybranej stronie": "Publish on the site of your choice",
        "Publikuj od": "Publish from",
        "PUT: Aktualizacja wpisu": "PUT: Update entry",
        "Pytania": "Questions",
        "Pytania i odpowiedzi": "Questions & Answers",
        "Pytanie": "Question",
        "Query string": "Query string",
        "Radio": "Radio",
        "Ranga": "Rank",
        "Recaptcha": "Recaptcha",
        "ReCaptcha": "ReCaptcha",
        "Redaktor został zaktualizowany.": "The editor has been updated.",
        "Region": "Region",
        "Regulamin wymagany": "Regulations required",
        "Regulamin został dodany.": "Regulations have been added.",
        "Regulamin został zaktualizowany.": "Ragulations have been updated.",
        "Regulaminy": "Regulations",
        "Reguła podatku": "Tax rule",
        "Rejestr zmian": "Changelog",
        "Rejestracja konta": "Sign-up",
        "Relacyjne": "Relational",
        "Repozytorium plików": "File repository",
        "Request body": "Request body",
        "Resetuj": "Reset",
        "Resetuj zmiany": "Reset changes",
        "RESTful API": "RESTful API",
        "Reżyseria": "Direction",
        "Ręczna akceptacja wszystkich komentarzy": "Manually accept all comments",
        "Rodzaj adresu kanonicznego": "Type of canonical address",
        "Rodzaj odpowiedzi": "Type of response",
        "Rodzaj źródła": "Type of source",
        "rok": "year",
        "Rok": "Year",
        "Rola": "Role",
        "Rola aktywna": "Active role",
        "Rola domyślna": "Default role",
        "Rola została dodana.": "The role has been added.",
        "Rola została usunięta.": "The role has been removed.",
        "Rola została zaktualizowana.": "The role has been updated.",
        "Role i uprawnienia": "Roles and permissions",
        "Role użytkownika": "User roles",
        "Role zespołu": "Roles of the team",
        "Role zostały przypisane": "Roles have been assigned",
        "Root": "Root",
        "Rotator": "Rotator",
        "Rotator został dodany.": "Rotator has been added.",
        "Rotator został usunięty.": "The rotator has been removed.",
        "Rotator został zaktualizowany.": "The rotator has been updated.",
        "Rotatory opinii": "Opinion rotators",
        "Rozdzielczość": "Resolution",
        "Rozdzielczość wygnerowanego obrazu.": "Resolution of the won image.",
        "Rozmiar": "Size",
        "Rozmiar okna popup": "Popup window size",
        "Rozmiar pliku": "File size",
        "Rozmiar podawany w bajtach.": "Size given in bytes.",
        "Rozmiar zdjęcia został zmieniony.": "The image has been resized.",
        "Rozmieść równomiernie": "Distribute evenly",
        "Rozwiń do": "Expand to",
        "Równość": "Equality",
        "RSS": "RSS",
        "Satysfakcja": "Satisfaction",
        "Scenariusz": "Scenario",
        "Scrollowalne okna popup": "Scrollable popup windows",
        "Sekcja": "Section",
        "Sekcja %0": "Section %0",
        "Sekcja modułu": "Module section",
        "Sekcja pod artykułem": "Section under the article",
        "Sekcja śródtekstowa": "Intra-text section",
        "Sekcje": "Sections",
        "Sekcje i bloki": "Sections and blocks",
        "SenderId": "SenderId",
        "Sentry": "Sentry",
        "Separator elementów w tytule": "Element separator in title",
        "Serial telewizyjny": "Television series",
        "Server Side Cache": "Server Side Cache",
        "Serwer bazy danych": "Database server",
        "Serwer dostępny": "Server available",
        "Serwer plików": "File server",
        "Serwer został dodany.": "Server has been added.",
        "Serwer został usunięty.": "Server has been removed.",
        "Serwer został zaktualizowany.": "Server has been updated.",
        "Serwery plików": "File servers",
        "Sesja": "Session",
        "Sesja nr %0": "Session No . %0",
        "Sesja użytkownika": "User's session has expired",
        "Sheduler": "Sheduler",
        "Sierpień": "August",
        "Skala 1-5": "Scale 1-5",
        "Sklep": "Shop",
        "Sklep został usunięty.": "The store has been removed.",
        "Sklepy": "Stores",
        "Skopiowano": "Copied",
        "Skopiuj kod": "Copy the code",
        "Skrócony opis": "Short description",
        "Skrypt": "Script",
        "Skrypty zewnętrzne": "External scripts",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "Scripts related to the collection of targeting data, e.g. Google Tag Manager, Facebook Pixel. Added at the top of <body> website.",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "Scripts related to the collection of statistics by external services, e.g. Analytics, Matomo. Added at the top of <head> site.",
        "Slajder": "Slider",
        "Slajder został dodany.": "The slider has been added.",
        "Slajder został usunięty.": "The slider has been removed.",
        "Slajder został zaktualizowany.": "The slider has been updated.",
        "Slajdery": "Sliders",
        "słowa": "words",
        "Słowa kluczowe": "Keywords",
        "Słowa oddzielone przecinkami.": "Words separated by commas.",
        "Słowa wykluczone": "Words excluded",
        "Słownik": "Dictionary",
        "Słownik dowolny": "Any dictionary",
        "Słownik systemowy": "System dictionary",
        "Słowo": "Word",
        "Słowo bazowe": "Base word",
        "Słowo wykluczone": "The word excluded",
        "Słowo zostało dodane.": "Word has been added.",
        "Słowo zostało usunięte.": "The word has been removed.",
        "Słowo zostało zaktualizowane.": "Word has been updated.",
        "Sobota": "Saturday",
        "Sortowanie": "Sorting",
        "Sortowanie autorów": "Author sorting",
        "Sortowanie cech": "Feature sorting",
        "Sortowanie grup cech": "Sorting groups of features",
        "Sortowanie kategorii": "Sorting categories",
        "Sortowanie malejąco": "Sort descending",
        "Sortowanie rosnąco": "Sort ascending",
        "Sortowanie wartości": "Sorting values",
        "Sortuj autorów": "Sort authors",
        "Sortuj cechy": "Sort features",
        "Sortuj grupy cech": "Sort feature groups",
        "Sortuj kategorie": "Sort Categories",
        "Sortuj wartości": "Sort values",
        "Specjalizowane": "Specialized",
        "Specyfikacja": "Specification",
        "Sposób dostawy": "Delivery method",
        "Sposób dostawy włączony": "Delivery method included",
        "Sposób dostawy został dodany.": "Delivery method has been added.",
        "Sposób dostawy został usunięty.": "The method of delivery has been removed.",
        "Sposób dostawy został zaktualizowany.": "The method of delivery has been updated.",
        "Sposób płatności włączony": "Payment method included",
        "Sposób płatności został dodany.": "Payment method has been added.",
        "Sposób płatności został usunięty.": "The payment method has been removed.",
        "Sposób płatności został zaktualizowany.": "The payment method has been updated.",
        "Sposób prezentacji zakładek": "The way bookmarks are presented",
        "Sposób wyświetlania kafelków kategorii w katalogu produktów": "How category tiles are displayed in the product catalog",
        "Sprawdzenie czy pusty": "Check if empty",
        "Stała wartość": "Constant value",
        "Stan powiadomienia": "Notification status",
        "Standardowa strona": "Standard page",
        "Standardowa szczegółowość": "Standard detail",
        "Standardowe uprawnienia": "Standard entitlements",
        "Stara cena brutto": "Old gross price",
        "Start": "Start",
        "Status": "Status",
        "Status aranżacji został zmieniony.": "The status of the arrangement has been changed.",
        "Status baneru został zmieniony.": "The status of the banner has been changed.",
        "Status dokumentu został zmieniony.": "The status of the document has been changed.",
        "Status edytowanej wersji dokumentu": "Status of the edited version of the document",
        "Status galerii został zmieniony.": "The status of the gallery has been changed.",
        "Status linku został zmieniony.": "The status of the link has been changed.",
        "Status modułu": "Module status",
        "Status płatności": "Payment status",
        "Status regulaminu został zmieniony.": "The status of the regulations has been changed.",
        "Status webhooka": "Webhook status",
        "Status wideo został zmieniony.": "The status of the video has been changed.",
        "Status zamówienia": "Order status",
        "Status żądania": "Status of request",
        "Status:": "Status:",
        "Statyczny": "Static",
        "Stawka aktywne": "Active rate",
        "Stawka domyślna": "Default rate",
        "Stawka została dodana.": "The rate has been added.",
        "Stawka została usunięta.": "The rate has been removed.",
        "Stawka została zaktualizowana.": "The rate has been updated.",
        "Stawki podatku w poszczególnych państwach": "Tax rates by country",
        "Stopka": "Footer",
        "Strefa czasowa": "Time zone",
        "Strona": "Page",
        "Strona %0": "Page %0",
        "Strona bez modułu": "Page without module",
        "Strona błędu": "Error page",
        "Strona docelowa dla 'Czytaj więcej'": "The landing page for 'Read more'",
        "Strona docelowa dla 'Kontakt z adminem'": "Destination page for 'Contact Admin'",
        "Strona docelowa dla 'Pliki cookies'": "Landing page for 'Cookies'",
        "Strona docelowa dla 'Polityka prywatności'": "Landing page for 'Privacy Policy'",
        "Strona dostępna dla wszystkich": "Website available to everyone",
        "Strona dostępna tylko dla zalogowanych użytkowników": "Page available only to logged in users",
        "Strona główna": "Home",
        "Strona logowania": "Login page",
        "Strona nadrzędna": "Parent page",
        "Strona opublikowana": "Published page",
        "Strona ukryta": "Hidden page",
        "Strona z błędem 404": "Page with 404 error",
        "Strona z modułu konto użytkownika": "Page from the user account module",
        "Strona z modułu wyszukiwarki": "Page from the search engine module",
        "Strona została dodana.": "The page has been added.",
        "Strona została usunięta.": "The page has been deleted.",
        "Strona została zaktualizowana.": "The page has been updated.",
        "Strony": "Page",
        "Strony gazetki": "Newspaper pages",
        "Struktura organizacyjna": "Organisational structure",
        "Struktura serwisu": "Site structure",
        "Studio": "Studio",
        "Stwierdzenie": "Statement",
        "Styczeń": "January",
        "Styl obrazu": "Image style",
        "Subskrypcja": "Subscription",
        "Subskrypcja aktywna": "Active subscription",
        "Subskrypcje": "Subscriptions",
        "Sukces": "Success",
        "Suma danych wejściowych i wyjściowych podana w tokenach.": "The sum of input and output data given in tokens.",
        "Suma tokenów": "Total tokens",
        "Symbol": "Symbol",
        "Symbol autora": "Author Symbol",
        "Symbol jest wymagany": "The symbol is required",
        "Symbol jest zajęty": "The symbol is occupied",
        "Symbol kategorii": "Category symbol",
        "Symbol klienta": "Customer symbol",
        "Symbol linku": "Link symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "The symbol can only consist of lowercase letters, numbers and the character -",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "A symbol can only consist of lowercase letters, numbers, and a character - ",
        "Symbol musi mieć co najmniej 3 znaki": "The symbol must have at least 3 characters",
        "Symbol musi mieć co najmniej 5 znaków": "The symbol must have at least 5 characters",
        "Symbol nie może być dłuższy niż 10 znaków": "The symbol must not be longer than 10 characters",
        "Symbol nie może być dłuższy niż 20 znaków": "The symbol must not be longer than 20 characters",
        "Symbol strony": "Page symbol",
        "Symbol w adresie URL": "Symbol in the URL",
        "Synchronizuj": "Sync",
        "Synonimy": "Synonyms",
        "Synonimy zostały dodane.": "Synonyms have been added.",
        "Synonimy zostały usunięte.": "Synonyms have been removed.",
        "Synonimy zostały zaktualizowane.": "Synonyms have been updated.",
        "System": "System",
        "System powiadomień": "Notification system",
        "Szablon graficzny": "Graphic template",
        "Szablon modułu": "Module template",
        "Szablon został dodany.": "The template has been added.",
        "Szablon został usunięty.": "The template has been removed.",
        "Szablon został zaktualizowany.": "The template has been updated.",
        "Szablony": "Templates",
        "Szacowana kwota:": "Estimated amount:",
        "Szczegółowość obrazu": "Image detail",
        "Szczegóły": "Details",
        "Szczegóły asystenta": "Assistant details",
        "Szczegóły elementu": "Element details",
        "Szczegóły klienta": "Customer details",
        "Szczegóły wartości": "Value details",
        "Szczegóły wpisu": "Entry details",
        "Szczegóły zadania": "Task details",
        "Szczegóły zamówienia": "Order details",
        "Szczegóły zapytania": "Details of the request",
        "Szczegóły zdarzenia": "Event details",
        "Szczegóły zdarzenia nr %0": "Details of event number %0",
        "Szerokość": "Width",
        "Szerokość strony": "Page width",
        "Szkic": "Draft",
        "Szukaj": "Search",
        "Szukaj we wszystkich wersjach": "Search in all versions",
        "Szukana fraza": "Search term",
        "Szukane słowo": "Search word",
        "Ścieżka aktywnej strony": "Path of the active page",
        "Ścieżka nawigacyjna": "Navigation path",
        "Średni": "Medium",
        "Środa": "Wednesday",
        "Środowisko": "Environment",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "This arrangement will be used if no other arrangement has been assigned to the site.",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "This site is protected by reCAPTCHA and Google.",
        "Tabela": "Table",
        "Tagi": "Tags",
        "Tak": "Yes",
        "Tak/Nie": "Yes/No",
        "Target": "Target",
        "Tekst": "Text",
        "Tekst alternatywny": "Alt text",
        "Tekst lokalizowany": "Localized text",
        "Tekst wyświetlany podczas ustawienia blokady": "Text displayed during lock setting",
        "Tekst zastępczy": "Alternative text",
        "Tekstowy / HTML / JS": "Text / HTML / JS",
        "Telefon": "Phone",
        "Ten dashboard nie zawiera jeszcze żadnych widgetów": "This dashboard does not yet contain any widgets",
        "Ten element nie zawiera menu kontekstowego.": "This item does not contain a context menu.",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel provides a possibility to send formatted text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel does not provide a possibility to send formatted text.",
        "Tenant ID": "Tenant ID",
        "Teraz": "Now",
        "Terminy dla kończących się subskrypcji": "Deadlines for expiring subscriptions",
        "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "You won't be able to add terms to the dictionary until you save the data source.",
        "Test konfiguracji": "Configuration test",
        "Test ustawień pomyślnie zakończony.": "Settings test successfully completed.",
        "Testowe": "Test",
        "Testowy adres email": "Tested email address",
        "Testowy numer telefonu": "Test phone number",
        "Testuj": "Test",
        "Testuj zapytanie": "Test Query",
        "Tłumaczenia": "Translations",
        "To pole jest wymagane": "This field is required",
        "Token": "Token",
        "Token został usunięty.": "Token has been removed.",
        "Tokeny": "Tokens",
        "Tokeny dostępu": "Access tokens",
        "Tokeny wejściowe": "Input tokens",
        "Tokeny wyjściowe": "Output Tokens",
        "Top temat został dodany.": "Top topic has been added.",
        "Top temat został usunięty.": "The top topic has been removed.",
        "Top temat został zaktualizowany.": "Top topic has been updated.",
        "Top tematy": "Top Topics",
        "Tracing": "Tracing",
        "Treści odpowiedzi są wymagane": "Answers are required",
        "Treści pytań są wymagane": "Questions are required",
        "Treść": "Content",
        "Treść komentarza": "Comment content",
        "Treść nie może być pusta.": "The content must not be empty.",
        "Trigger": "Trigger",
        "Trwa generowanie formularza": "Form generation in progress",
        "Trwa generowanie obrazów": "Image generation in progress",
        "Trwa generowanie obrazu": "Image generation in progress",
        "Trwa generowanie opisu dla wybranego obrazu": "Description generation for the selected image is in progress",
        "Tryb konserwacji systemu": "System maintenancemMode",
        "Tryb wyświetlania": "Display mode",
        "Trzy kolumny": "Three columns",
        "Twoje hasło wygasło. Zmień je na nowe.": "Your password has expired. Change it to new one.",
        "Tworzenie dokumentów": "Document creation",
        "Twój token": "Your token",
        "tydzień": "week",
        "Tydzień": "Week",
        "Tylko 404": "Only 404",
        "Tylko aktywne": "Only active",
        "Tylko do odczytu": "Read-only",
        "tylko dokumenty wersjonowane": "versioned documents only",
        "Tylko gdy odpowiedź serwera jest 404": "Only when the server response is 404",
        "Tylko liderzy": "Only the leaders",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Lowercase letters only, no special characters, numbers, and spaces.",
        "Tylko priorytetowe": "Priority only",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Development server only. Do not use in production mode. ",
        "Tylko treść": "Content only",
        "Tylko zalogowani użytkownicy mogą zgłaszać komentarze": "Only logged-in users can report comments",
        "Typ": "Type",
        "Typ aranżacji": "Type of arrangement",
        "Typ autora": "Author type",
        "Typ bannera": "Banner type",
        "Typ długości": "Length type",
        "Typ długości pakietu": "Type of package length",
        "Typ konta": "Account type",
        "Typ logowania": "Login type",
        "Typ mime": "Mime type",
        "Typ obiektu": "Object type",
        "Typ obiektu:": "Object type:",
        "Typ pakietu": "Package type",
        "Typ pliku": "File type",
        "Typ pola": "Field type",
        "Typ powiadomienia": "Notification type",
        "Typ rankingu": "Ranking type",
        "Typ serwera": "Server type",
        "Typ słownika": "Dictionary type",
        "Typ strony": "Page type",
        "Typ właściwy": "The right type",
        "Typ zestawu": "Set type",
        "Typ źródła": "Source type",
        "Typ źródła danych": "Data source type",
        "typu \"%0\" o ID \"%1\"": "of type \"%0\" with ID \"%1\"",
        "Tytuł": "Title",
        "Tytuł aktywnej witryny": "Title of the active site",
        "Tytuł elementu": "Element title",
        "Tytuł formularza jest wymagany": "Form title is required",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "The title of the form cannot be longer than %0 znaków",
        "Tytuł okładki": "Cover title",
        "Tytuł przerwy technicznej": "Technical Break Title",
        "Tytuł sekcji": "Section title",
        "Tytuł strony": "Page title",
        "Tytuł witryny": "Site title",
        "Udało się zapisać ustawienia widgetów": "Successfully saved widget settings",
        "Układ": "Arrangement",
        "Układ listy": "List layout",
        "Ukryj kafelki": "Hide tiles",
        "Ukryta": "Hidden",
        "Ukryty": "Hidden",
        "Ulica": "Street",
        "Upload": "Upload",
        "Uprawnienia": "Permissions",
        "Uprawnienia do dokumentów": "Entitlement to documents",
        "Uprawnienia zostały usunięte.": "Entitlements have been removed.",
        "Url": "Url",
        "URL": "URL",
        "URL płatności": "Payment URL",
        "Uruchom zadanie": "Run the task",
        "Urządzenie zostało usunięte.": "The device has been removed.",
        "Usługi": "Services",
        "Ustaw kategorię": "Set category",
        "Ustaw również dla wszystkich podstron": "Set also for all subpages",
        "Ustaw szerokości proporcjonalnie": "Set widths proportionally",
        "Ustawienia": "Settings",
        "Ustawienia domyślne": "Default settings",
        "Ustawienia dostępności": "Accessibility settings",
        "Ustawienia Dotpay": "Dotpay settings",
        "Ustawienia Firebase": "Firebase settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia limitu kupieckiego": "Merchant limit settings",
        "Ustawienia PayPal": "PayPal settings",
        "Ustawienia PayU": "PayU settings",
        "Ustawienia płatności": "Payment settings",
        "Ustawienia płatności zostały zaktualizowane.": "Payment settings have been updated.",
        "Ustawienia podstawowe": "Basic settings",
        "Ustawienia powiadomień zostały zaktualizowane.": "Your notification settings have been updated.",
        "Ustawienia przelewu tradycyjnego": "Traditional transfer settings",
        "Ustawienia Przelewy24": "Settings of Przelewy24",
        "Ustawienia redakcji": "Editorial settings",
        "Ustawienia rotatora": "Rotator settings",
        "Ustawienia sekcji \"%0\"": "Settings of the \"%0\" section",
        "Ustawienia sesji": "Session settings",
        "Ustawienia sklepu": "Store settings",
        "Ustawienia slajdera": "Slider settings",
        "Ustawienia strony": "Page settings",
        "ustawienia widgetu": "widget settings",
        "Ustawienia widgetu": "Widget settings",
        "Ustawienia witryny": "Site settings",
        "Ustawienia zaawansowane": "Advanced settings",
        "Ustawienia zostały zaktualizowane.": "The settings have been updated.",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "usunął": "removed",
        "Usunął": "Deleted",
        "Usunięcie": "Deletion",
        "Usunięcie dokumentu": "Document deletion",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nnCzy na pewno chcesz usunąć wybrany formularz?": "Delete formannOperation is irreversible. All related documents will be lost!nnAre you sure you want to delete the selected form?",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "Delete indexunnOperation is irreversible. Are you sure you want to delete the selected index?",
        "Usunięcie wybranych elementów": "Delete selected items",
        "Usunięto wybraną wersję aranżacji.": "A selected version of the arrangement has been removed.",
        "usunięty": "removed",
        "Usuń": "Delete",
        "Usuń artykuł z listy": "Remove an article from the list",
        "Usuń autora": "Delete author",
        "Usuń blok z sekcji": "Remove a block from a section",
        "Usuń cechę": "Remove feature",
        "Usuń charmonogram": "Remove charmonogram",
        "Usuń datę": "Delete date",
        "Usuń dział": "Delete department",
        "Usuń filtr": "Remove filter",
        "Usuń grupę": "Delete the group",
        "Usuń indeks": "Delete index",
        "Usuń katalog": "Delete directory",
        "Usuń kategorię": "Delete category",
        "Usuń odpowiedź": "Delete answer",
        "Usuń opinię": "Delete opinion",
        "Usuń plik": "Delete file",
        "Usuń plik z listy": "Remove the file from the list",
        "Usuń powiązanie": "Unlink",
        "Usuń powód": "Remove reason",
        "Usuń pozycję": "Delete item",
        "Usuń publikację": "Delete a publication",
        "Usuń pytanie": "Delete question",
        "Usuń regulamin": "Delete regulations",
        "Usuń sekcję": "Delete section",
        "Usuń slajd": "Delete slide",
        "Usuń słowo": "Delete word",
        "Usuń spacje": "Remove spaces",
        "Usuń stronę": "Delete page",
        "Usuń tag": "Remove tag",
        "Usuń urządzenie": "Remove device",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "Remove device to cancel remembered automatic logins to your account",
        "Usuń wybraną wersję aranżacji": "Delete the selected version of the arrangement",
        "Usuń wybrany element": "Delete the selected item",
        "Usuń z zespołu": "Remove from team",
        "Usuń zestaw": "Delete set",
        "Usuń${checkedItems.length > 1 ? ' zaznaczone' : ''}": "Delete${checkedItems.length > 1 ? ' selected : ''}",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "Delete${selected.length > 1 ? ' selected : ''}",
        "Usuwanie dokumentów": "Deletion of documents",
        "Usuwanie użytkowników": "Deleting users",
        "Usuwanie własnych dokumentów": "Deleting your own documents",
        "Usuwanie wszystkich dokumentów": "Deleting all documents",
        "Utworzył": "Author",
        "Utwórz grupy": "Create groups",
        "Utwórz katalog": "Create a directory",
        "Utwórz kopię formularza": "Create a copy of the form",
        "Utwórz kopię z": "Create a copy from",
        "Utwórz nowy": "Create new",
        "Utwórz nowy wątek": "Create a new thread",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "NOTE: No TypeScript support and you cannot do imports in the method code.",
        "Uwzględnij dodatkowe koszty pakowania produktów": "Take into account the additional cost of product packaging",
        "Uwzględnij wydziały podrzędne": "Include sub-departments",
        "Użyte narzędzie": "Tool used",
        "Użytkownicy": "Users",
        "Użytkownicy mogą zgłaszać komentarze do moderacji": "Users can submit comments for moderation",
        "Użytkownicy w tej roli": "Users in this role",
        "Użytkownik": "User",
        "Użytkownik \"%0\" %1 obiekt %2": "User \"%0\" %1 obiect %2",
        "Użytkownik jest liderem zespołu": "The user is a team leader",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "The user cannot log in until the account is active.",
        "Użytkownik nie należy do żadnego zespołu.": "The user does not belong to any team.",
        "Użytkownik posiada pełne uprawnienia": "The user has full permissions",
        "Użytkownik z bazy": "User from the base",
        "Użytkownik zalogowany": "Logged in user",
        "Użytkownik został dodany do zespołu.": "The user has been added to the team.",
        "Użytkownik został dodany.": "The user has been added.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został wylogowany.": "The user has been logged out.",
        "Użytkownik został zaktualizowany.": "The user has been updated.",
        "Użytkownik został zanonimizowany.": "The user has been anonymized.",
        "Użytkownikcy z bazy": "Users from the base",
        "Użyty Model": "Model Used",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "The following variables are available in the body of the validation method:",
        "W każdy dzień tygodnia": "Every day of the week",
        "W organizacji nie ma jeszcze żadnych działów.": "There are no sections in the organization yet.",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "If the value is missing, the name of the site will be displayed.",
        "W przyszłości": "In the future",
        "W tym katalogu nie ma jeszcze żadnych kategorii.": "There are no categories in this catalog yet.",
        "W tym katalogu nie ma jeszcze żadnych stron.": "There are no pages in this directory yet.",
        "W zespole od %0": "In the team from %0",
        "W zespole od %0 do %1": "In the team from %0 to %1",
        "Waga": "Weight",
        "Walidacja": "Validation",
        "Walidacja certyfikatu SSL": "SSL certificate validation",
        "Walidacja danych": "Data validation",
        "Walidacja po stronie API": "Validation on the API side",
        "Walidacja typów MIME": "MIME type validation",
        "Waluta": "Currency",
        "Waluta została dodana.": "Currency has been added.",
        "Waluta została zaktualizowana.": "The currency has been updated.",
        "Waluty": "Currencies",
        "Wartości cechy": "Trait values",
        "Wartości liczbowa": "Numerical values",
        "Wartości numeryczne": "Numerical values",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "Values from 0 - 1.0 (0 means 0% and 1 means 100%)",
        "Wartości tekstowa": "Text values",
        "Wartości wymagana": "Required values",
        "Wartość": "Value",
        "Wartość długości": "Length value",
        "Wartość domyślna": "Default value",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "Default value: (&(objectClass=organizationalUnit))",
        "Wartość domyślna: (&(objectClass=user)": "Default value: (&(objectClass=user)",
        "Wartość musi być liczbą całkowitą": "The value must be an integer",
        "Wartość musi być liczbą dodatnią": "The value must be a positive number",
        "Wartość musi być liczbą ujemną": "The value must be a negative number",
        "Wartość numeryczna": "Numerical value",
        "Wartość tekstowa": "Text value",
        "Wartość została dodana.": "Value has been added.",
        "Wartość została zaktualizowana.": "The value has been updated.",
        "Warunki korzystania z usług Google": "Google's terms of service",
        "Warunki logiczne": "Logical conditions",
        "Warunkowo": "Conditionally",
        "Ważne informacje": "Important information",
        "Ważne: Moduł ten obsługuje wyłącznie linki wewnętrzne, tj. odnoszące się do zasobów w ramach tej samej domeny i serwisu. Adresy należy podawać jako pełne ścieżki, na przykład: /stara-strona oraz /nowa-strona.": "Important: This module supports only internal links, i.e. referring to resources within the same domain and site. Addresses should be given as full paths, for example: /old-page and /new-page.",
        "Ważność": "Validity",
        "Wątek": "Thread",
        "Wątek główny": "Main thread",
        "Wątek główny jest kontynuowany automatycznie przez asystenta.": "The main thread is continued automatically by the assistant.",
        "Wczytywanie danych...": "Loading data...",
        "Webhook": "Webhook",
        "Webhook został dodany.": "Webhook has been added.",
        "Webhook został usunięty.": "Webhook has been removed.",
        "Webhook został zaktualizowany.": "The webhook has been updated.",
        "Webhooki": "Webhooks",
        "Weekend": "Weekend",
        "Wersja API": "API version",
        "Wersja językowa": "Language version",
        "Wersja nieopublikowana": "Unpublished version",
        "Wersja opublikowana": "Published version",
        "Wersja robocza została przywrócona.": "The draft version has been restored.",
        "Wersja utowrzona przez": "Version created by",
        "Wersje": "Versions",
        "Wersje aranżacji": "Arrangement versions",
        "Wersje dokumentu": "Document versions",
        "wersji zaakceptowanej": "accepted version",
        "Wersjonowanie": "Versioning",
        "Wersjonowanie dokumentów włączone": "Versioning of documents enabled",
        "Wersjonowanie dokumentów wyłączone": "Versioning of documents disabled",
        "Wersjonowanie można włączyć tylko podczas dodawania nowego formularza.": "Versioning can only be enabled when adding a new form.",
        "Wewnętrznie": "Internally",
        "Wewnętrzny": "Internal",
        "Wiadomość testowa została wysłana.": "A test message has been sent.",
        "Wiadomość została wysłana.": "The message has been sent.",
        "Wideo": "Video",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "The video is not yet published anywhere.",
        "Wideo nie ma ustawionej daty publikacji.": "The video does not have a publication date set.",
        "Wideo premium": "Premium video",
        "Wideo zostało dodane.": "Video has been added.",
        "Wideo zostało usunięte.": "The video has been removed.",
        "Wideo zostało zaktualizowane.": "The video has been updated.",
        "Widgety": "Widgets",
        "Widoczność": "Visibility",
        "Widoczność modułu w menu": "Module visibility in the menu",
        "Widoczność sekcji w menu modułu": "Section visibility in the module menu",
        "Widoczny obszar": "Visible area",
        "Widok czołówki - zdjęcie z tytułem": "Front view - photo with title",
        "Widok ustawień": "Settings view",
        "Wielkość kroku": "Step size",
        "Wielokrotny wybór": "Multiple choice",
        "Wiersz": "Row",
        "Więcej": "More",
        "więcej...": "more...",
        "Więcej...": "More…",
        "Witryna": "Website",
        "Witryna / Wersja językowa": "Website / Language version",
        "Witryna aktywna": "Active site",
        "Witryna domyślna": "Default site",
        "Witryna i język": "Site and language",
        "Witryna internetowa": "Website",
        "Witryna tylko dla zalogowanych użytkowników": "Site for logged-in users only",
        "Witryna została dodana.": "The site has been added.",
        "Witryna została usunięta.": "The site has been removed.",
        "Witryna została zaktualizowana.": "The site has been updated.",
        "Witryny": "Sites",
        "Wklej komponent": "Paste component",
        "Właściwości": "Characteristics",
        "Właściwości szablonu": "Template properties",
        "Właściwość ``%0`` aktywnego wpisu": "The ''%0'' feature of the active entry",
        "Włącz": "Turn on",
        "Włącz ankietę": "Enable survey",
        "Włącz formularz kontaktowy": "Enable contact form",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "Enable at least one language version for your site to start managing your pages.",
        "Włącz social media": "Enable social media",
        "Włącz system komentarzy": "Enable the comment system",
        "Włącz walidację po stronie API": "Enable validation on the API side",
        "Włącza bardzo restrykcyjne sprawdzanie typów MIME dla wysyłanych plików. W przypadku zgłaszania błędów dla plików, których zawartości jesteśmy pewni, należy tą opcję pozostawić nieaktywną.": "Enables very restrictive MIME type checking for uploaded files. When reporting errors for files whose contents we are sure of, leave this option disabled.",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "Enable sitemap.xml file generation for the website",
        "Włączenie moderacji danych wejściowych jest zalecane.": "Enabling input moderation is recommended.",
        "Włączenie obsługi cacheu dla witryny": "Enable cache support for the website",
        "Włączenie protokołu SSL dla tej witryny": "Enable SSL for this site",
        "Włączone": "Enabled",
        "Włączone (Follow)": "Enabled (Follow)",
        "Włączone (Index)": "Enabled (Index)",
        "Włączony": "Enabled",
        "Województwo": "Province",
        "Wpis aktywny": "Active entry",
        "Wpis do kalendarza został usunięty.": "The calendar entry has been removed.",
        "Wpis do kalendarza został zaktualizowany.": "The calendar entry has been updated.",
        "Wpis domyślny": "Default entry",
        "Wpis w kalendarzu został dodany.": "The calendar entry has been added.",
        "Wpis w kalendarzu został zaktualizowany.": "The calendar entry has been updated.",
        "Wpis został dodany.": "The post has been added.",
        "Wpis został usunięty.": "The post has been deleted.",
        "Wpis został zaakceptowany.": "The post has been accepted.",
        "Wpis został zaktualizowany.": "The post has been updated.",
        "Wpisy zostały usunięte.": "The entries have been deleted.",
        "Wpisy zostały zaakceptowane.": "The entries have been accepted.",
        "Wpisz adresy po przecinku.": "Enter the addresses after the comma.",
        "Wpisz wiadomość": "Type your message",
        "Wpływ na wariantowość produktu": "Impact on product variability",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "We enter the URL to the seriws we want to exclude. The data can be separated by a comma or on a new line",
        "Wprowadzona wartość jest nieprawidłowa": "The value you entered is invalid",
        "Wprowadzona wartość jest za długa": "The value you entered is too long",
        "Wprowadzona wartość jest za krótka": "The value you entered is too short",
        "Wprowadzona wartość jest za niska": "The value you entered is too low",
        "Wprowadzona wartość jest za wysoka": "The value you entered is too high",
        "Wprowadzona wartość nie jest poprawna": "The value you entered is not valid",
        "Wprowadź link": "Enter link",
        "Wróć do logowania": "Back to login",
        "Wróć do strony głównej": "Back to Home Page",
        "Wrzesień": "September",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "It indicates to search engine robots whether to index the page.",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "It indicates to search engine robots whether to follow the links.",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "Indicates how long the response remains valid in Redis server memory.",
        "Wstaw cztery kolumny 1/4": "Insert four columns 1/4",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "Insert two columns 1/3 and 2/3",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "Insert two columns 2/3 and 1/3",
        "Wstaw dwie równe kolumny": "Insert two equal columns",
        "Wstaw kontrolkę": "Insert control",
        "Wstaw stronę": "Insert page",
        "Wstaw szablon informacyjny ze zdjęciem": "Insert information template with photo",
        "Wstaw trzy kolumny 1/3": "Insert three columns 1/3",
        "Wstaw z dołu": "Insert from below",
        "Wstaw z góry": "Insert from above",
        "Wstaw z lewej strony": "Insert left",
        "Wstaw z prawej strony": "Insert right",
        "Wstecz": "Back",
        "Wstęp": "Introduction",
        "Wstępne filtrowanie danych": "Pre-filtering the data",
        "Wszystkie": "All",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "All of the user's personal information in the system will be deleted!nnAre you sure you want to perform the action?",
        "Wszystkie kraje": "All countries",
        "Wszystkie niezapisane zmiany zostaną utracone.": "Any unsaved changes will be lost.",
        "Wszystkie próby": "All attempts",
        "Wszystko": "All",
        "Wtorek": "Tuesday",
        "wybierz": "select",
        "Wybierz": "Select",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "Select a canonical address from the list or enter it manually.",
        "Wybierz ankietę": "Select a survey",
        "Wybierz artykuł": "Select article",
        "Wybierz autora": "Select author",
        "Wybierz blok": "Select block",
        "Wybierz cechę": "Select feature",
        "Wybierz czołówkę": "Choose a headlamp",
        "Wybierz datę": "Select a date",
        "Wybierz datę lub wprowadź wartość tekstową": "Select a date or enter a text value",
        "Wybierz daty publikacji": "Select publication dates",
        "wybierz długość": "choose length",
        "Wybierz domyślną kategorię": "Choose a default category",
        "Wybierz formularz": "Select a form",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "Select a form with additional fields for user accounts",
        "Wybierz galerię": "Select a gallery",
        "Wybierz istniejącego użytkownika": "Select an existing user",
        "wybierz katalog": "select directory",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "Select the directory to which you want to move the selected items.",
        "Wybierz kategorię": "Select a category",
        "Wybierz kategorię subskrypcji": "Select a subscription category",
        "Wybierz link z serwisu": "Select a link from the site",
        "Wybierz listę regulaminów": "Select a list of regulations",
        "wybierz model": "select model",
        "Wybierz plik": "Select file",
        "Wybierz plik lub katalog": "Select file or directory",
        "Wybierz plik.": "Select the file.",
        "Wybierz pliki": "Select files",
        "Wybierz pliki (do {0})": "Select files (to {0})",
        "Wybierz poziom": "Select level",
        "Wybierz regulamin": "Select regulations",
        "Wybierz sekcję": "Select section",
        "Wybierz serwer": "Select server",
        "Wybierz shortcode": "Select shortcode",
        "Wybierz stronę": "Select page",
        "Wybierz stronę do opublikowania": "Select a page to publish",
        "Wybierz strony": "Select pages",
        "wybierz szablon": "select template",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Select the notification type to see the available keys.",
        "Wybierz użytkownika": "Select user",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Select the users for whom you want to perform actions",
        "Wybierz wątek w którym chcesz prowadzić konwersację.": "Choose the thread in which you want to have a conversation.",
        "Wybierz wideo": "Select video",
        "Wybierz zakres godzinowy": "Select an hourly range",
        "Wybierz zaznaczone": "Choose selected",
        "wybierz...": "select...",
        "Wybierz...": "Select...",
        "Wybór": "Choice",
        "Wybór języka": "Language",
        "Wybór listy stron": "Selection of the list of pages",
        "Wybór strony": "Site selection",
        "Wybór+": "Choice+",
        "Wybrana data jest mniejsza niż dozwolona %0.": "Selected date is before the permitted one %0.",
        "Wybrana data jest większa niż dozwolona %0.": "Selected date is above the permitted one %0.",
        "Wybrana ikona powinna być kwadratem": "The selected icon should be a square",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "Selected number is lesser than allowed %0.",
        "Wybrana liczba jest większa niż dozwolona %0.": "Selected number is greater then allowed %0.",
        "Wybrane": "Selected",
        "Wybrane artykuły": "Items in cart",
        "Wybrane dokumenty": "Selected documents",
        "Wybrane elementy zostały przeniesione.": "The selected items have been moved.",
        "Wybrane elementy zostały usunięte.": "The selected items have been removed.",
        "Wybrane pliki": "Selected files",
        "Wybrane pliki: {0}": "Selected files: {0}",
        "Wybrane regulaminy:": "Selected regulations:",
        "Wybrane: %0": "Selected: %0",
        "Wybranie ankiety jest wymagane": "Selecting a survey is required",
        "Wybranie katalogu jest wymagane": "Selecting a directory is required",
        "Wybranie strony jest wymagane": "Selecting a page is required",
        "Wybrano": "Selected",
        "Wybrano %0 użytkowników.": "%0 uusers selected.",
        "Wybrano jednego użytkownika.": "One user was selected.",
        "Wybrany język": "Selected language",
        "Wybrany szablon": "Selected template",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "The selected character will replace the separator marker | inserted in the title.",
        "Wybróbuj możliwości AI": "Sample the capabilities of AI",
        "Wyczyść": "Clear",
        "Wyczyść aranżację": "Clear arrangement",
        "Wydział": "Department",
        "Wygenerowana odpowiedź przez model AI.": "The generated response by the AI model.",
        "Wygenerowane obrazy": "Generated images",
        "Wygeneruj metadane dla przesyłanych obrazów": "Generate metadata for uploaded images",
        "Wygląd": "Look",
        "Wyklucz logowanie zależności": "Exclude dependency logging",
        "Wykonaj": "Do",
        "Wykonawca": "Author",
        "Wykorzystane": "Used",
        "Wykresy": "Charts",
        "Wyloguj się": "Log out",
        "Wyloguj zalogowanego obecnie użytkownika": "Log off the currently logged in user",
        "Wyłaczone": "Off",
        "Wyłącz cenę": "Turn off the price",
        "Wyłącz cenę z historii": "Exclude price from history",
        "Wyłącz komentarze": "Turn off comments",
        "Wyłącz udostępnij dalej": "Turn off share",
        "Wyłączone (NoFollow)": "Off (NoFollow)",
        "Wyłączone (NoIndex)": "Disabled (NoIndex)",
        "Wyłączone komentarze": "Comments Off on",
        "Wyłączone przez": "Excluded by",
        "Wyłączone udostępnianie": "Disabled sharing",
        "Wyłączony": "Disabled",
        "Wymagaj ponownej akceptacji po zmianach": "Require re-approval after changes",
        "Wymagaj znaków specjalnych w hasłach": "Require special characters in passwords",
        "Wymagane": "Required",
        "Wymagane jest ustawienie minimalnej długości hasła": "Minimum password length is required",
        "Wymagane jest wybranie formularza": "It is required to select the form",
        "Wymagane jest wybranie kategorii": "It is required to select a category",
        "Wymagane jest wybranie komponentu": "It is required to select a component",
        "Wymagane jest wybranie modułu": "It is required to select the module",
        "Wymagane jest wybranie sekcji": "A section must be selected",
        "Wymagane jest wybranie wersji językowej": "It is required to select the language version",
        "Wymagane jest wybranie witryny": "It is required to select a site",
        "Wymagane jest wybranie zestawu regulaminów": "It is required to select a set of regulations",
        "Wymagane jest wybranie źródła danych": "Data source is required",
        "Wymagane znaki": "Required characters",
        "Wymagany kod pocztowy": "Required postal code",
        "Wymiary": "Dimensions",
        "Wymuś zmianę hasła": "Force password change",
        "Wynik testu": "Test result",
        "Wyniki": "Results",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "The test results will always be limited to a maximum of 10 items.",
        "Wyniki_": "Results_",
        "Wyrażenia warunkowe": "Conditional expressions",
        "Wyrażenie regularne": "Regular expression",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "Expression in the form \"/pattern/flag\" is not supported, use pattern values alone",
        "Wyrażone zgody": "Consents given",
        "Wysłane": "Sent",
        "Wysoka szczegółowość": "High level of detail",
        "Wysoki": "High",
        "Wysokość": "Height",
        "Wysokość strony": "Page height",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "An error occurred while loading the image. Try again.",
        "Wystąpił błąd podczas próby exportu przekierowań.": "An error occurred while trying to export redirects.",
        "Wystąpił błąd podczas próby exportu użytkowników.": "An error occurred while trying to export users.",
        "Wystąpił błąd podczas próby importu definicji modułu.": "An error occurred while trying to import a module definition.",
        "Wystąpił błąd podczas próby importu przekierowań.": "An error occurred while trying to import redirects.",
        "Wystąpił błąd podczas próby importu użytkowników.": "An error occurred while trying to import users.",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "A connection error has occurred. Make sure you are online and try again.",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "A server error occurred while handling the selected operation. Please try again.",
        "Wystąpił problem podczas przesyłania obrazu.": "There was a problem while uploading the image.",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "There were errors in the form. Check all fields of the form.",
        "Wysyłaj dane o użytkowniku": "Send user data",
        "Wysyłaj tym kanałem": "Send through this channel",
        "Wyszukaj (Ctrl+Q)": "Search (Ctrl+Q)",
        "Wyszukaj albo dodaj nową kategorię": "Search or add a new category",
        "Wyszukaj albo dodaj nowy tag": "Search for or add a new tag",
        "Wyszukaj autora...": "Search for author...",
        "Wyszukaj blok": "Search blocks",
        "Wyszukaj czołówkę...": "Search headline...",
        "Wyszukaj formularz...": "Search Form...",
        "Wyszukaj kategorię": "Search a category",
        "Wyszukaj regulamin...": "Search for regulations...",
        "Wyszukaj tag": "Search tag",
        "wyszukaj użytkownika...": "search for user...",
        "Wyszukaj użytkownika...": "Search user...",
        "Wyszukaj widget": "Search widget",
        "Wyszukaj wszędzie": "Search everywhere",
        "Wyszukaj...": "Search...",
        "Wyszukiwanie": "Search",
        "Wyszukiwanie plików": "File Search",
        "Wyszukiwanie plików umożliwia asystentowi korzystanie z wiedzy z plików. Po przesłaniu pliku asystent automatycznie decyduje, kiedy pobrać treść, na podstawie żądań użytkownika.": "File Search allows the assistant to use knowledge from files. Once a file is uploaded, the assistant automatically decides when to download the content, based on user requests.",
        "Wyszukiwany ciąg znaków": "Search set of characters",
        "Wyślij": "Send",
        "Wyślij kod": "Send the code",
        "Wyślij link do potwierdzenia maila": "Send email confirmation link",
        "Wyślij powiadomienie - Ilość dni po zakończeniu subskrypcji:": "Send notification - Number of days after subscription ends:",
        "Wyślij powiadomienie - Ilość dni przed zakończeniem subskrypcji:": "Send notification - Number of days before your subscription ends:",
        "Wyślij wiadomość": "Send message",
        "Wyświetlaj artykuł na całą stronę": "Display article for full page",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "Display a list of articles with a thumbnail image",
        "Wyświetlaj nazwę bloczka": "Display block name",
        "Wyświetlaj opinie z tłem": "Display feedback with background",
        "Wyświetlaj tylko treść": "Display content only",
        "Wyświetlaj tytuł": "Display title",
        "Wyświetlam": "Displaying",
        "Wyświetlanie dokumentów": "Displaying documents",
        "Wytnij": "Cut",
        "Wywołanie funkcji": "Calling the function",
        "Wyzeruj licznik": "Reset counter",
        "Wyżej": "Above",
        "Wzorzec": "Pattern",
        "Wzór kodu pocztowego": "Postal code template",
        "Wzór kodu pocztowego, który będzie wyświetlany w komunikacie błędnej walidacji": "Pattern of the postal code that will be displayed in the error validation message",
        "YouTube (ID)": "YouTube (ID)",
        "Z uprawnieniami": "With authority",
        "Z uprawnieniami do modułu": "With permission to module",
        "Zaakceptowany": "Accepted",
        "Zaawansowane polecenia": "Advanced commands",
        "Zaawansowane uprawnienia": "Advanced powers",
        "Zabierz dostęp": "Take away access",
        "Zablokowany": "Blocked",
        "Zablokuj": "Block",
        "Zachowaj oryginalny format obrazów": "Preserve original image format",
        "zacznij pisać aby wyszukać ankietę...": "start typing to search for a survey....",
        "zacznij pisać aby wyszukać ankiety...": "start writing to search for surveys....",
        "zacznij pisać aby wyszukać artykuł...": "start typing to search for an article...",
        "zacznij pisać aby wyszukać autora...": "start typing to search for an author...",
        "zacznij pisać aby wyszukać cechę...": "start writing to search for a feature....",
        "zacznij pisać aby wyszukać galerię...": "start typing to search the gallery....",
        "zacznij pisać aby wyszukać grupę...": "start writing to search for a group....",
        "zacznij pisać aby wyszukać kategorię...": "start typing to search for a category...",
        "zacznij pisać aby wyszukać kraj...": "start typing to search for a country....",
        "zacznij pisać aby wyszukać podatek...": "start writing to search for tax....",
        "zacznij pisać aby wyszukać rotator...": "start typing to search for rotator....",
        "zacznij pisać aby wyszukać slajder...": "start typing to search for a slider...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search for a user...",
        "Zacznij pisać aby wyszukać użytkownika...": "Start typing to search for a user...",
        "zacznij pisać aby wyszukać walutę...": "start writing to search for currency....",
        "zacznij pisać aby wyszukać wideo...": "start typing to search for video....",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "Start typing Form or Entry to start prompting.",
        "Zaczyna sie od": "Starts with",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "The task of rebuilding the indexes has begun.",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "The task of reindexing the data has begun.",
        "Zadanie zostało uruchomione.": "The task has started.",
        "Zadanie zostało włączone": "Task has been enabled",
        "Zadanie zostało wyłączone": "Task has been disabled",
        "Zagrożenie": "Threat",
        "Zaimportowano definicję modułu.": "A module definition has been imported.",
        "Zaimportowano listę przekierowań.": "A list of redirects has been imported.",
        "Zaimportowano listę użytkowników.": "A list of users has been imported.",
        "Zakładki": "Bookmarks",
        "Zakolejkowane": "Pending",
        "Zakończ edycje": "Finish editions",
        "Zakończ sesję": "End the session",
        "Zakończ sesję aby wylogować użytkownika": "End session to log the user out",
        "Zakończone": "Completed",
        "Zakres": "Range",
        "Zakres czasu": "Time range",
        "Zaktualizowano.": "Updated.",
        "Zaktualizuj formularz": "Update form",
        "Zależna od kontrolki": "Control dependent",
        "Zalogowany": "Logged in",
        "Zaloguj się": "Sign In",
        "Zaloguj się na swoje konto": "Log in to your account",
        "Załączniki": "Attachments",
        "Załączniki premium": "Premium attachments",
        "Zamawianie bez rejestracji, przez niezalogowanych klientów": "Ordering without registration, by not logged in customers",
        "Zamiany zostały zapisane.": "The changes have been saved.",
        "Zamknij": "Close",
        "Zamówienia": "Orders",
        "Zamówienie": "Order",
        "Zamówienie zostało zaktualizowane.": "The order has been updated.",
        "Zamówiony pakiet": "Ordered package",
        "Zaokrąglenie": "Rounding",
        "Zapamiętaj logowanie": "Remember login",
        "Zapamiętane urządzenia": "Memorized devices",
        "Zapisuj logi": "Save logs",
        "Zapisywanie obrazów zakończone.": "Image storage completed.",
        "Zapisz": "Save",
        "Zapisz filtr": "Save filter",
        "Zapisz i wróć": "Save and return",
        "Zapisz i zamknij": "Save and close",
        "Zapisz ustawienia": "Save your settings",
        "Zapisz ustawienia widgetów": "Save widget settings",
        "Zapisz wartość": "Save the value",
        "Zapisz wersję roboczą": "Save the draft version",
        "Zapisz widget": "Save widget",
        "Zapisz wybrane": "Save the selected",
        "Zapisz zmiany": "Save changes",
        "Zaplanowane": "Scheduled",
        "Zapomniałeś hasła?": "Forgot your password?",
        "Zapytanie SQL do pobrania po ID": "SQL query to retrieve by ID",
        "Zapytanie SQL do wyszukiwania": "SQL query for searching",
        "Zarządzanie witrynami": "Manage sites",
        "Zasięg": "Range",
        "Zastępstwa": "Substitutions",
        "Zastępstwo": "Add a substitution",
        "Zastępstwo wygasło.": "The substitution has expired.",
        "Zastępstwo wygaśnie za 10 minut.": "The substitution will expire in 10 minutes.",
        "Zastępstwo wygaśnie za 5 minut.": "The substitution will expire in 5 minutes.",
        "Zastępstwo wygaśnie za minutę.": "The substitution will expire in a minute.",
        "Zastępstwo zostało dodane.": "The substitution has been added.",
        "Zastępstwo zostało usunięte.": "The substitution has been removed.",
        "Zastępstwo zostało zaktualizowane.": "The substitution has been updated.",
        "Zastępuje osobę": "Substituting",
        "Zastosuj zmiany w aplikacji": "Apply changes to the application",
        "Zatwierdź": "Approve",
        "Zatwierdź${checkedItems.length > 1 ? ' zaznaczone' : ''}": "Approve${checkedItems.length > 1 ? ' selected : ''}",
        "Zaufane adresy IP": "Trusted IP addresses",
        "Zawiera": "Contains",
        "Zawiera sekcje": "Contains sections",
        "Zawierające jeden z wybranych tagów": "Containing one of the selected tags",
        "Zawsze": "Always",
        "Zaznacz": "Select",
        "Zaznacz wszystkie": "Select all",
        "Zaznaczone": "Marked",
        "Zaznaczone (${checkedItems.value.length})": "Selected (${checkedItems.value.length})",
        "Zdarzenie": "Event",
        "Zdjęcia": "Photos",
        "Zdjęcie": "Photo",
        "Zdjęcie autora": "Photo by the author",
        "Zdjęcie dla tabletów": "Photo for tablets",
        "Zdjęcie dla urządzeń mobilnych": "Photo for mobile devices",
        "Zdjęcie główne": "Main photo",
        "Zdjęcie na okładce": "Cover photo",
        "Zdjęcie użytkownika": "User's photo",
        "Zdjęcie w tle": "Background photo",
        "Zespoły": "Teams",
        "Zespół": "Team",
        "Zespół aktywny": "Active team",
        "Zespół został dodany.": "The team has been added.",
        "Zespół został usunięty.": "The team has been removed.",
        "Zespół został zaktualizowany.": "The team has been updated.",
        "Zestaw": "Set",
        "Zestaw niestandardowy": "Custom set",
        "Zestaw został dodany.": "The set has been added.",
        "Zestaw został zaktualizowany.": "The set has been updated.",
        "Zewnętrzne skrypty statystyk": "External statistics scripts",
        "Zewnętrzne skrypty targetujące": "External targeting scripts",
        "Zewnętrzny": "External",
        "Zewnętrzny serwis": "External service",
        "Zgłaszanie komentarzy": "Reporting comments",
        "Zgłoszenia": "Issues",
        "Zgoda": "Consent",
        "Zmiana hasła": "Password change",
        "Zmiana rozmiaru obrazu": "Resize an image",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "Changing the settings may result in loss of access to the panel!nnAre you sure you want to save the changes?",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "Changes to monitoring settings require a restart of the application.",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "The changes will not take effect until the indexes are rebuilt.",
        "Zmiany zostały zapisane.": "Changes saved.",
        "Zmiany zostaną zastosowane w aplikacji w przeciągu kikunastu sekund": "Changes will be applied to the application in a matter of seconds",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "The variable %HEAD_TITLE% can be used in other text boxes.",
        "Zmieniono ustawienia widgetu": "Widget settings changed",
        "Zmień daty publikacji": "Change publication dates",
        "Zmień hasło": "Change password",
        "Zmień nazwę": "Rename",
        "Zmień nazwę katalogu": "Rename a directory",
        "Zmień nazwę pliku": "Rename a file",
        "Zmień rozmiar": "Resize",
        "Zmień status edytowanej wersji": "Change the status of the edited version",
        "Zmień widok": "Change view",
        "Zmniejsz": "Reduce",
        "zmodyfikował": "modified",
        "Zmodyfikował": "Modified by",
        "zmodyfikowany": "modified",
        "Znajdź typ bloku...": "Find the type of block...",
        "znaki": "characters",
        "Znaki specialne": "Special characters",
        "Zobacz przed opublikowaniem": "View before publishing",
        "Zobacz sesję użytkownika": "View user session",
        "Zobacz szczegóły sesji użytkownika": "View user session details",
        "Zobacz szczegóły zdarzenia": "View event details",
        "Zobacz wszystkie": "See all",
        "Zobacz wszystkie zastępstwa": "See all substitutions",
        "Został przywrócony oryginalny harmonogram": "Original schedule has been restored",
        "został wysłany": "was sent",
        "Zresetuj hasło": "Reset password",
        "Zrestartuj aplikacje": "Restart applications",
        "Zrezygnowano z subskrypcji": "Subscriptions cancelled",
        "Zwrócony": "Returned",
        "Źródła danych": "Data Sources",
        "Źródła LDAP": "LDAP sources",
        "Źródło": "Source",
        "Źródło aktywne": "Active source",
        "Źródło danych": "Data source",
        "źródło danych zostało dodane.": "the data source has been added.",
        "Źródło danych zostało zaktualizowane.": "The data source has been updated.",
        "Źródło LDAP zostało dodane.": "LDAP source has been added.",
        "Źródło LDAP zostało zaktualizowane.": "The LDAP source has been updated.",
        "Źródło URL": "URL source",
        "źródło zostało usunięte.": "the source has been removed.",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "No communication channel has been enabled in the notification settings.",
        "Żródło danych": "Data source"
    }
};
